/**
 * MoreShapes — Iter 175 Section Audit
 *
 * Per-template miniature preview SVG/HTML shapes for the Add Section
 * modal. Replaces the previous "all-same-per-category" generic preview
 * with one visually-distinct shape per template across shop, pricing,
 * testimonials, contact, footer, faq, auth-account, donations, videos,
 * calendar, menus, audio, charts, forms, newsletter, social, portfolio,
 * images, group-events, content-memberships, scheduling, and the long-
 * tail catch-alls. Each shape is purely presentational and renders at
 * 100% of its tile container so the Add Section modal can drop them
 * straight into its grid without any sizing logic.
 */
import React from 'react';

const IMG = {
  prod1:  'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=70',
  prod2:  'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&q=70',
  prod3:  'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&q=70',
  prod4:  'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=400&q=70',
  fash1:  'https://images.unsplash.com/photo-1483356350331-89d7a4827b62?w=400&q=70',
  fash2:  'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=400&q=70',
  food:   'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&q=70',
  food2:  'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&q=70',
  studio: 'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=400&q=70',
  team:   'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&q=70',
  port1:  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&q=70',
  port2:  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&q=70',
  port3:  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&q=70',
  mount:  'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=600&q=70',
  beach:  'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=70',
  art:    'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&q=70',
  city:   'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600&q=70',
};

const L = ({ w='60%', h=2, mt=4, c='#CBD5E1', op=1 }) =>
  <div style={{ width:w, height:h, background:c, opacity:op, borderRadius:2, marginTop:mt }} />;

const Chip = ({ c='#0E0E23', children, fg='#fff' }) => (
  <span style={{ background:c, color:fg, fontSize:5, fontWeight:900, letterSpacing:0.6, padding:'2px 5px', borderRadius:999, textTransform:'uppercase' }}>{children}</span>
);

// ════════════════════ SHOP (8) ════════════════════
const ShopGrid3Col = () => (
  <div style={{ background:'#FAFAF9', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:6 }}>Best-Selling Products</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gridTemplateRows:'1fr 1fr', gap:4 }}>
      {[IMG.prod1, IMG.prod2, IMG.prod3, IMG.fash1, IMG.fash2, IMG.prod4].map((s,i)=>(
        <div key={i}><img src={s} alt="" style={{ width:'100%', aspectRatio:'1/1', objectFit:'cover', borderRadius:3 }}/></div>
      ))}
    </div>
  </div>
);
const ShopGrid4Col = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:6 }}>Latest Products</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:3 }}>
      {Array.from({length:8}).map((_,i)=>(
        <div key={i} style={{ background:i%3===0?'#F1F5F9':'#E2E8F0', aspectRatio:'1/1', borderRadius:2, position:'relative' }}>
          <div style={{ position:'absolute', bottom:1, left:2, right:2, fontSize:4, color:'#475569' }}>${(i+1)*15}</div>
        </div>
      ))}
    </div>
  </div>
);
const ShopSwatches = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:6 }}>Your Daily Dose of Inspiration</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:4 }}>
      {[IMG.fash1, IMG.fash2, IMG.prod3, IMG.prod1].map((s,i)=>(
        <div key={i}>
          <img src={s} alt="" style={{ width:'100%', aspectRatio:'1/1.2', objectFit:'cover', borderRadius:3 }}/>
          <div style={{ display:'flex', gap:1.5, marginTop:2 }}>
            {['#EF4444','#3B82F6','#10B981','#0E0E23'].map((cc,k)=>(<div key={k} style={{ width:5, height:5, borderRadius:999, background:cc }}/>))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
const ShopPDPClassic = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', display:'flex', gap:6 }}>
    <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
      {[IMG.prod1, IMG.prod2, IMG.prod3].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:14, height:14, objectFit:'cover', borderRadius:2, opacity:i===0?1:0.5 }}/>))}
    </div>
    <img src={IMG.prod1} alt="" style={{ width:'40%', aspectRatio:'1/1', objectFit:'cover', borderRadius:3 }}/>
    <div style={{ flex:1 }}>
      <Chip c="#FCD34D" fg="#0E0E23">FEATURED</Chip>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:4 }}>Featured Product</div>
      <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', marginTop:2 }}>$199</div>
      <L w="80%" mt={6}/><L w="65%" mt={3}/>
      <div style={{ marginTop:6, background:'#0E0E23', color:'#fff', fontSize:6, fontWeight:900, padding:'4px 8px', borderRadius:3, textAlign:'center', letterSpacing:0.8 }}>ADD TO CART</div>
    </div>
  </div>
);
const ShopPDPFashion = () => (
  <div style={{ background:'#FAF6EE', padding:6, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
    <img src={IMG.fash1} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:3 }}/>
    <div style={{ display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ fontSize:5, letterSpacing:1.5, color:'#7C2D12', fontWeight:900, textTransform:'uppercase' }}>Bags</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Braided Shoulder Bag</div>
      <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', marginTop:2 }}>$220</div>
      <div style={{ display:'flex', gap:3, marginTop:6 }}>
        {['S','M','L'].map(sz=>(<div key={sz} style={{ width:12, height:12, border:'1px solid #0E0E23', fontSize:5, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center', color:'#0E0E23' }}>{sz}</div>))}
      </div>
      <div style={{ display:'flex', gap:2, marginTop:4 }}>
        {['#7C2D12','#0E0E23','#A78BFA'].map((cc,k)=>(<div key={k} style={{ width:6, height:6, borderRadius:999, background:cc }}/>))}
      </div>
    </div>
  </div>
);
const ShopCart = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', marginBottom:6 }}>Your Cart</div>
    {[{n:'Sample Product A', p:'$29.99', q:1}, {n:'Sample Product B', p:'$49.99', q:2}].map((it,i)=>(
      <div key={i} style={{ display:'flex', gap:5, alignItems:'center', borderBottom:'1px solid #F1F5F9', padding:'4px 0' }}>
        <div style={{ width:16, height:16, background:'#F1F5F9', borderRadius:2 }}/>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:6, fontWeight:800, color:'#0E0E23' }}>{it.n}</div>
          <div style={{ fontSize:5, color:'#94A3B8' }}>Qty {it.q}</div>
        </div>
        <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>{it.p}</div>
      </div>
    ))}
    <div style={{ marginTop:5, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <div style={{ fontSize:6, color:'#0E0E23', fontWeight:900 }}>Total</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23' }}>$129.97</div>
    </div>
    <div style={{ marginTop:5, background:'#10B981', color:'#fff', fontSize:6, fontWeight:900, padding:'4px 0', borderRadius:3, textAlign:'center' }}>CHECKOUT</div>
  </div>
);
const ShopCategoryFilter = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 2.4fr', gap:6 }}>
    <div style={{ background:'#F8FAFC', padding:4, borderRadius:3 }}>
      <div style={{ fontSize:5, fontWeight:900, color:'#0E0E23', letterSpacing:0.6, textTransform:'uppercase' }}>FILTERS</div>
      <div style={{ marginTop:4 }}>
        {['Category','Price','Color','Size'].map((f,i)=>(<div key={i} style={{ marginBottom:2 }}><L w={i%2?'60%':'80%'} mt={0} c="#0E0E23" op={0.5}/></div>))}
      </div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gridAutoRows:'1fr', gap:3 }}>
      {Array.from({length:6}).map((_,i)=>(<div key={i} style={{ background:i%2?'#F1F5F9':'#E2E8F0', aspectRatio:'1/1', borderRadius:2 }}/>))}
    </div>
  </div>
);
const ShopGradientPromos = () => (
  <div style={{ padding:6, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr', gap:6, background:'#fff' }}>
    {[{c:'linear-gradient(135deg, #8B5CF6, #EC4899)', t:'Limited Edition'}, {c:'linear-gradient(135deg, #F97316, #EF4444)', t:'75% Off Sale'}].map((p,i)=>(
      <div key={i} style={{ background:p.c, padding:8, borderRadius:4, color:'#fff', display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
        <div style={{ fontSize:9, fontWeight:900, lineHeight:1.1 }}>{p.t}</div>
        <div style={{ background:'#fff', color:'#0E0E23', fontSize:5, fontWeight:900, padding:'3px 6px', borderRadius:2, alignSelf:'flex-start' }}>SHOP →</div>
      </div>
    ))}
  </div>
);

// ── Iter 189c Phase B · Products — new premium variants (drawn thumbs) ──
const ShopDualCollection = () => (
  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:3, width:'100%', height:'100%', padding:8, background:'#fff' }}>
    {[
      { grad:'linear-gradient(135deg,#7C2D12,#0E0E23)', name:'Fine Jewelry', cta:'Shop the Fine' },
      { grad:'linear-gradient(135deg,#312E81,#A78BFA)', name:'Everyday', cta:'Shop Everyday' },
    ].map((col, i) => (
      <div key={i} style={{ background: col.grad, borderRadius:8, padding:10, display:'flex', flexDirection:'column', justifyContent:'flex-end', color:'#fff', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg,transparent 40%,rgba(0,0,0,0.55))' }} />
        <div style={{ position:'relative' }}>
          <div style={{ fontSize:4.5, fontWeight:800, letterSpacing:1.4, textTransform:'uppercase', opacity:0.7 }}>Collection 0{i+1}</div>
          <div style={{ fontSize:14, fontWeight:900, marginTop:3, lineHeight:1.05, fontFamily:'Georgia,serif' }}>{col.name}</div>
          <div style={{ fontSize:5, marginTop:4, opacity:0.85 }}>{col.cta} →</div>
        </div>
      </div>
    ))}
  </div>
);

const ShopEditorialLookbook = () => (
  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6, width:'100%', height:'100%', padding:8, background:'#fff' }}>
    <div style={{ position:'relative', aspectRatio:'4/5', background:'linear-gradient(135deg,#292524,#F5F5F4)', borderRadius:4, overflow:'hidden' }}>
      <div style={{ position:'absolute', top:3, left:3, fontSize:4, color:'#fff', background:'rgba(0,0,0,0.4)', padding:'1px 4px', borderRadius:99, fontWeight:900, letterSpacing:1.2 }}>Issue 04</div>
    </div>
    <div style={{ paddingTop:4 }}>
      <div style={{ fontSize:4.5, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>THE LOOKBOOK</div>
      <div style={{ fontSize:13, fontWeight:900, color:'#0E0E23', marginTop:3, lineHeight:1.05, fontFamily:'Georgia,serif' }}>Quiet objects,</div>
      <div style={{ fontSize:13, fontWeight:900, color:'#0E0E23', lineHeight:1.05, fontFamily:'Georgia,serif' }}>loud stories.</div>
      <div style={{ fontSize:5, color:'#475569', marginTop:4, opacity:0.75 }}>Six new pieces.</div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:2, marginTop:6 }}>
        {[0,1,2].map(i => (
          <div key={i} style={{ position:'relative', aspectRatio:'1/1', background:`hsl(${(i+1)*60}, 20%, 78%)`, borderRadius:2 }}>
            <div style={{ position:'absolute', top:1, left:1, fontSize:3.5, color:'#fff', background:'rgba(0,0,0,0.55)', padding:'0.5px 2px', borderRadius:2, fontFamily:'monospace', fontWeight:900 }}>0{i+1}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const SHOP_SHAPE_BY_ID = {
  'shop-3col': ShopGrid3Col, 'shop-4col': ShopGrid4Col, 'shop-swatches': ShopSwatches,
  'shop-pdp-classic': ShopPDPClassic, 'shop-pdp-fashion': ShopPDPFashion,
  'shop-cart': ShopCart, 'shop-cat-filter': ShopCategoryFilter, 'shop-promos': ShopGradientPromos,
  // Iter 189c Phase B — new premium Products variants
  'shop-dual-collection':     ShopDualCollection,
  'shop-editorial-lookbook':  ShopEditorialLookbook,
};

// ════════════════════ PRICING (7) ════════════════════
const PricingTabs = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ display:'flex', gap:3, justifyContent:'center', marginBottom:5 }}>
      {['MONTHLY','ANNUAL'].map((t,i)=>(<div key={i} style={{ fontSize:5, fontWeight:900, padding:'3px 6px', borderRadius:3, background:i===0?'#0E0E23':'#F1F5F9', color:i===0?'#fff':'#475569', letterSpacing:0.6 }}>{t}</div>))}
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4 }}>
      {[{n:'Starter',p:'$0'},{n:'Pro',p:'$19',hi:true},{n:'Master',p:'$49'}].map((t,i)=>(
        <div key={i} style={{ background:t.hi?'#0E0E23':'#F8FAFC', color:t.hi?'#fff':'#0E0E23', padding:6, borderRadius:3, textAlign:'center', transform:t.hi?'translateY(-3px)':'none' }}>
          <div style={{ fontSize:5, opacity:0.7, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>{t.n}</div>
          <div style={{ fontSize:13, fontWeight:900, marginTop:2 }}>{t.p}</div>
          <L w="80%" mt={4} c={t.hi?'#fff':'#CBD5E1'} op={0.4}/><L w="60%" mt={2} c={t.hi?'#fff':'#CBD5E1'} op={0.4}/>
        </div>
      ))}
    </div>
  </div>
);
const PricingCompare = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center', marginBottom:6 }}>Compare Plans</div>
    <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr 1fr 1fr', fontSize:5, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase', color:'#94A3B8', borderBottom:'1px solid #E2E8F0', paddingBottom:3 }}>
      <div>Features</div><div style={{ textAlign:'center' }}>Starter</div><div style={{ textAlign:'center', color:'#8B5CF6' }}>Pro</div><div style={{ textAlign:'center' }}>Master</div>
    </div>
    {[1,2,3,4,5].map(i=>(
      <div key={i} style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr 1fr 1fr', padding:'3px 0', fontSize:5, color:'#475569', borderBottom:'1px dashed #F1F5F9' }}>
        <div style={{ paddingLeft:1 }}><L w="80%" mt={0}/></div>
        <div style={{ textAlign:'center', color:i<3?'#10B981':'#CBD5E1' }}>{i<3?'✓':'—'}</div>
        <div style={{ textAlign:'center', color:'#10B981' }}>✓</div>
        <div style={{ textAlign:'center', color:'#10B981' }}>✓</div>
      </div>
    ))}
  </div>
);
const PricingPAYG = () => (
  <div style={{ background:'#F8FAFC', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:4 }}>Pay as you go</div>
    <div style={{ background:'#fff', borderRadius:3, padding:5 }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', fontSize:4, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase', color:'#94A3B8', borderBottom:'1px solid #E2E8F0', paddingBottom:2 }}>
        <div>Tier</div><div>Usage</div><div style={{ textAlign:'right' }}>Price</div>
      </div>
      {[{t:'Free',u:'≤ 100',p:'$0'},{t:'Starter',u:'1K',p:'$9'},{t:'Growth',u:'10K',p:'$29'},{t:'Scale',u:'100K',p:'$99'}].map((r,i)=>(
        <div key={i} style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', padding:'3px 0', fontSize:5, color:'#0E0E23', borderBottom:i<3?'1px dashed #F1F5F9':'none', alignItems:'center' }}>
          <div style={{ fontWeight:800 }}>{r.t}</div><div style={{ color:'#94A3B8' }}>{r.u}</div><div style={{ textAlign:'right', fontWeight:900 }}>{r.p}</div>
        </div>
      ))}
    </div>
  </div>
);
const PricingFeatureSpec = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:5 }}>What&rsquo;s Inside?</div>
    {[{k:'CPU',v:'Quad-core'},{k:'Memory',v:'16 GB'},{k:'Storage',v:'512 GB'},{k:'Network',v:'1 Gbps'}].map((r,i)=>(
      <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'3px 4px', background:i%2?'#F8FAFC':'transparent', borderRadius:2, fontSize:6 }}>
        <div style={{ color:'#0E0E23', fontWeight:800 }}>{r.k}</div>
        <div style={{ color:'#475569' }}>{r.v}</div>
      </div>
    ))}
    <div style={{ marginTop:3, background:'#10B981', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center' }}>ALL INCLUDED</div>
  </div>
);
const PricingDarkHero = () => (
  <div style={{ background:'#0B0F1A', padding:10, width:'100%', height:'100%', color:'#fff' }}>
    <div style={{ fontSize:8, fontWeight:900, textAlign:'center' }}>Pick your plan</div>
    <div style={{ fontSize:5, opacity:0.6, textAlign:'center', marginTop:1 }}>Power up your business</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4, marginTop:6 }}>
      {[{n:'Starter',p:'$9'},{n:'Pro',p:'$29',hi:true},{n:'Master',p:'$99'}].map((t,i)=>(
        <div key={i} style={{ background:t.hi?'#F97316':'rgba(255,255,255,0.06)', padding:6, borderRadius:3, textAlign:'center' }}>
          <div style={{ fontSize:5, opacity:0.8, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>{t.n}</div>
          <div style={{ fontSize:11, fontWeight:900, marginTop:2 }}>{t.p}</div>
        </div>
      ))}
    </div>
  </div>
);
const PricingMiddlePop = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center', marginBottom:5 }}>Simple, flexible pricing</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4, alignItems:'center' }}>
      {[{n:'Starter',p:'$0'},{n:'Pro',p:'$19',hi:true},{n:'Master',p:'$49'}].map((t,i)=>(
        <div key={i} style={{ background:t.hi?'#0E0E23':'#fff', color:t.hi?'#fff':'#0E0E23', padding:t.hi?9:6, borderRadius:4, textAlign:'center', boxShadow:t.hi?'0 4px 10px rgba(0,0,0,0.15)':'0 1px 3px rgba(0,0,0,0.05)', transform:t.hi?'scale(1.1)':'none' }}>
          <div style={{ fontSize:5, opacity:0.7, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>{t.n}</div>
          <div style={{ fontSize:t.hi?12:10, fontWeight:900, marginTop:2 }}>{t.p}</div>
          {t.hi && <Chip c="#F97316">POPULAR</Chip>}
        </div>
      ))}
    </div>
  </div>
);
const PricingMembership = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Membership</div>
    <div style={{ fontSize:5, color:'#94A3B8', textAlign:'center', marginTop:1 }}>Join the inner circle</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:5, marginTop:6 }}>
      {[{n:'Monthly',p:'$19',sub:'Cancel anytime'},{n:'Annual',p:'$190',sub:'2 months free',hi:true}].map((t,i)=>(
        <div key={i} style={{ background:t.hi?'#8B5CF6':'#F8FAFC', color:t.hi?'#fff':'#0E0E23', padding:7, borderRadius:4, textAlign:'center' }}>
          <div style={{ fontSize:5, opacity:0.7, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>{t.n}</div>
          <div style={{ fontSize:11, fontWeight:900, marginTop:2 }}>{t.p}</div>
          <div style={{ fontSize:4, marginTop:2, opacity:0.8 }}>{t.sub}</div>
        </div>
      ))}
    </div>
  </div>
);

// ── Iter 189c Phase B · Pricing — new premium variants (drawn thumbs) ──
const PricingWithTestimonial = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:8 }}>
    <div style={{ textAlign:'center', marginBottom:6 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>PRICING</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Pick the plan that fits.</div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3 }}>
      {[
        { name:'Starter', price:'$0', hi:false },
        { name:'Pro',     price:'$29', hi:true  },
        { name:'Studio',  price:'$99', hi:false },
      ].map((t, i) => (
        <div key={i} style={{ background: t.hi ? '#0E0E23' : '#fff', color: t.hi ? '#fff' : '#0E0E23', border: t.hi ? 'none' : '1px solid #E2E8F0', borderRadius:4, padding:5, transform: t.hi ? 'translateY(-3px)' : 'none' }}>
          {t.hi && <div style={{ background:'#8B5CF6', color:'#fff', fontSize:3.5, padding:'1px 3px', borderRadius:99, display:'inline-block', letterSpacing:1, fontWeight:900 }}>POPULAR</div>}
          <div style={{ fontSize:5, fontWeight:900, marginTop: t.hi ? 3 : 0 }}>{t.name}</div>
          <div style={{ fontSize:11, fontWeight:900, marginTop:1 }}>{t.price}</div>
        </div>
      ))}
    </div>
    <div style={{ marginTop:8, padding:6, background:'rgba(139,92,246,0.08)', border:'1px solid rgba(139,92,246,0.25)', borderRadius:4, textAlign:'center' }}>
      <div style={{ display:'flex', gap:1, justifyContent:'center', marginBottom:3 }}>
        {[0,1,2,3,4].map(i => <span key={i} style={{ color:'#F59E0B', fontSize:6 }}>★</span>)}
      </div>
      <div style={{ fontSize:5, fontStyle:'italic', color:'#0E0E23', fontFamily:'Georgia,serif' }}>&quot;Pro paid for itself in a week.&quot;</div>
      <div style={{ fontSize:4, fontWeight:900, color:'#0E0E23', marginTop:2 }}>Sam Rivera · Kindred</div>
    </div>
  </div>
);

const PricingAnnualToggle = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:8 }}>
    <div style={{ textAlign:'center', marginBottom:5 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>BILLING</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:1 }}>One price. All features.</div>
      <div style={{ display:'inline-flex', alignItems:'center', gap:2, marginTop:4, background:'rgba(14,14,35,0.06)', padding:2, borderRadius:99 }}>
        <div style={{ background:'#0E0E23', color:'#fff', fontSize:4, fontWeight:900, padding:'2px 6px', borderRadius:99, letterSpacing:1, textTransform:'uppercase' }}>Monthly</div>
        <div style={{ fontSize:4, color:'#0E0E23', fontWeight:900, padding:'2px 5px', opacity:0.6, letterSpacing:1, textTransform:'uppercase', display:'flex', alignItems:'center', gap:2 }}>
          Yearly<span style={{ background:'#8B5CF6', color:'#fff', fontSize:3, padding:'0.5px 2px', borderRadius:99, fontWeight:900 }}>-20%</span>
        </div>
      </div>
    </div>
    <div style={{ position:'relative' }}>
      <div style={{ position:'absolute', top:-3, left:'50%', transform:'translateX(-50%) rotate(-6deg)', background:'#8B5CF6', color:'#fff', fontSize:3.5, fontWeight:900, padding:'1px 4px', borderRadius:99, letterSpacing:1, textTransform:'uppercase', zIndex:2 }}>Save $60/yr</div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3, marginTop:5 }}>
        {[
          { name:'Starter', price:'$9', hi:false },
          { name:'Pro',     price:'$29', hi:true  },
          { name:'Studio',  price:'$79', hi:false },
        ].map((t, i) => (
          <div key={i} style={{ background: t.hi ? '#0E0E23' : '#fff', color: t.hi ? '#fff' : '#0E0E23', border: t.hi ? 'none' : '1px solid #E2E8F0', borderRadius:4, padding:5 }}>
            <div style={{ fontSize:5, fontWeight:900 }}>{t.name}</div>
            <div style={{ fontSize:11, fontWeight:900, marginTop:1 }}>{t.price}<span style={{ fontSize:4, opacity:0.6, fontWeight:400 }}>/mo</span></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const PRICING_SHAPE_BY_ID = {
  'pricing-tabs': PricingTabs, 'pricing-compare': PricingCompare, 'pricing-payg': PricingPAYG,
  'pricing-feature-spec': PricingFeatureSpec, 'pricing-dark-hero': PricingDarkHero,
  'pricing-middle-pop': PricingMiddlePop, 'pricing-membership': PricingMembership,
  // Iter 189c Phase B — new premium Pricing variants
  'pricing-with-testimonial': PricingWithTestimonial,
  'pricing-annual-toggle':    PricingAnnualToggle,
};

// ════════════════════ TESTIMONIALS (7) ════════════════════
const TSingle = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center' }}>
    <div style={{ fontSize:24, color:'#8B5CF6', lineHeight:0.6, marginBottom:3 }}>“</div>
    <div style={{ fontSize:9, fontFamily:'Georgia, serif', color:'#0E0E23', fontStyle:'italic', lineHeight:1.3 }}>A truly exceptional team.</div>
    <div style={{ fontSize:5, fontWeight:900, color:'#475569', marginTop:5, letterSpacing:0.6, textTransform:'uppercase' }}>— Customer</div>
  </div>
);
const TThreeUp = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:5 }}>
    {['Loved it.','Would recommend.','Five stars.'].map((q,i)=>(
      <div key={i} style={{ background:'#F8FAFC', padding:6, borderRadius:3 }}>
        <div style={{ color:'#F59E0B', fontSize:7 }}>★★★★★</div>
        <div style={{ fontSize:6, color:'#0E0E23', marginTop:3, lineHeight:1.3, fontFamily:'Georgia, serif', fontStyle:'italic' }}>{q}</div>
        <div style={{ fontSize:4, fontWeight:900, color:'#94A3B8', marginTop:3, letterSpacing:0.6 }}>— {['A','B','C'][i]}.</div>
      </div>
    ))}
  </div>
);
const TImage = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', display:'flex' }}>
    <img src={IMG.port1} alt="" style={{ width:'45%', height:'100%', objectFit:'cover' }}/>
    <div style={{ flex:1, padding:12, display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ color:'#F59E0B', fontSize:9 }}>★★★★★</div>
      <div style={{ fontSize:8, color:'#0E0E23', marginTop:4, fontFamily:'Georgia, serif', fontStyle:'italic', lineHeight:1.3 }}>&ldquo;Outstanding craftsmanship.&rdquo;</div>
      <div style={{ fontSize:5, fontWeight:900, color:'#475569', marginTop:5, letterSpacing:0.6, textTransform:'uppercase' }}>— Name · Returning</div>
    </div>
  </div>
);
const TMarquee = () => (
  <div style={{ background:'#0E0E23', color:'#fff', width:'100%', height:'100%', display:'flex', alignItems:'center', padding:10, overflow:'hidden' }}>
    <div style={{ display:'flex', gap:14, fontSize:11, fontFamily:'Georgia, serif', fontStyle:'italic' }}>
      <span>&ldquo;Stunning&rdquo;</span><span style={{ opacity:0.4 }}>·</span>
      <span>&ldquo;Best in class&rdquo;</span><span style={{ opacity:0.4 }}>·</span>
      <span>&ldquo;Highly recommend&rdquo;</span>
    </div>
  </div>
);
const TCta = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
    <div style={{ flex:1, background:'#F8FAFC', padding:8, borderRadius:3, marginBottom:6 }}>
      <div style={{ fontSize:7, fontFamily:'Georgia, serif', color:'#0E0E23', fontStyle:'italic' }}>&ldquo;Game changer.&rdquo;</div>
      <div style={{ fontSize:4, color:'#94A3B8', marginTop:2 }}>— Customer</div>
    </div>
    <div style={{ background:'#8B5CF6', color:'#fff', textAlign:'center', padding:5, borderRadius:3, fontSize:6, fontWeight:900 }}>Read more reviews →</div>
  </div>
);
const TQuotePortrait = () => (
  <div style={{ background:'#fff', padding:12, width:'100%', height:'100%', display:'flex', gap:10, alignItems:'center' }}>
    <img src={IMG.port3} alt="" style={{ width:36, height:36, borderRadius:999, objectFit:'cover' }}/>
    <div style={{ flex:1 }}>
      <div style={{ fontSize:7, fontFamily:'Georgia, serif', color:'#0E0E23', fontStyle:'italic', lineHeight:1.3 }}>&ldquo;Best decision I made all year.&rdquo;</div>
      <div style={{ fontSize:5, fontWeight:900, color:'#475569', marginTop:4, letterSpacing:0.6, textTransform:'uppercase' }}>Sarah K. · CEO Acme Co.</div>
    </div>
  </div>
);
const TAuthorCards = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center', marginBottom:5 }}>What our clients say</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4 }}>
      {[IMG.port1, IMG.port2, IMG.port3].map((p,i)=>(
        <div key={i} style={{ background:'#F8FAFC', padding:4, borderRadius:3, textAlign:'center' }}>
          <div style={{ color:'#F59E0B', fontSize:6 }}>★★★★★</div>
          <div style={{ fontSize:5, color:'#0E0E23', marginTop:2, lineHeight:1.3, fontFamily:'Georgia, serif', fontStyle:'italic' }}>&ldquo;Loved working with the team.&rdquo;</div>
          <img src={p} alt="" style={{ width:14, height:14, borderRadius:999, marginTop:3, objectFit:'cover' }}/>
          <div style={{ fontSize:4, fontWeight:900, color:'#475569', marginTop:2 }}>{['Maya L.','Jordan T.','Alex R.'][i]}</div>
        </div>
      ))}
    </div>
  </div>
);

// ── Iter 189c Phase B · Testimonials — new premium variants (drawn thumbs) ──
const TWallOfLove = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:6, display:'flex', flexDirection:'column' }}>
    <div style={{ textAlign:'center', marginBottom:5 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>LOVED BY THE CRAFT</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:1 }}>A wall of love.</div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3 }}>
      {[
        { name:'Maya L.', h:44 },
        { name:'Jordan T.', h:32 },
        { name:'Alex R.', h:48 },
        { name:'Sam K.', h:36 },
        { name:'Priya V.', h:40 },
        { name:'Leo S.', h:34 },
      ].map((t, i) => (
        <div key={i} style={{ background:'#fff', border:'1px solid #E2E8F0', borderRadius:3, padding:4, height:t.h, boxShadow:'0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ display:'flex', gap:0.5, marginBottom:2 }}>
            {[0,1,2,3,4].map(si => <span key={si} style={{ color:'#F59E0B', fontSize:3.5 }}>★</span>)}
          </div>
          <div style={{ fontSize:3.5, color:'#0E0E23', opacity:0.85, lineHeight:1.3 }}>Loved every second.</div>
          <div style={{ fontSize:3, fontWeight:800, color:'#0E0E23', marginTop:2 }}>{t.name}</div>
        </div>
      ))}
    </div>
  </div>
);

const TInterviewHero = () => (
  <div style={{ display:'grid', gridTemplateColumns:'1fr 1.4fr', gap:6, width:'100%', height:'100%', padding:8, background:'#fff' }}>
    <div>
      <div style={{ aspectRatio:'4/5', background:'linear-gradient(160deg,#F5F5F4,#E7E5E4)', borderRadius:3, overflow:'hidden' }}>
        <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
      </div>
      <div style={{ fontSize:3.5, fontWeight:900, letterSpacing:1.4, textTransform:'uppercase', opacity:0.6, marginTop:3 }}>MONOCLE 24</div>
    </div>
    <div style={{ paddingTop:4 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>INTERVIEW</div>
      <div style={{ display:'flex', gap:3, marginTop:6, alignItems:'flex-start' }}>
        <div style={{ fontSize:12, opacity:0.3, fontFamily:'Georgia,serif', fontWeight:900, lineHeight:0.9 }}>Q.</div>
        <div style={{ fontSize:8, fontFamily:'Georgia,serif', fontWeight:900, color:'#0E0E23', lineHeight:1.15 }}>How did the rebrand change your business?</div>
      </div>
      <div style={{ display:'flex', gap:3, marginTop:5, alignItems:'flex-start' }}>
        <div style={{ fontSize:12, color:'#8B5CF6', fontFamily:'Georgia,serif', fontWeight:900, lineHeight:0.9 }}>A.</div>
        <div style={{ fontSize:5, color:'#0E0E23', opacity:0.85, lineHeight:1.3 }}>Night and day. We went from one of a dozen to the one people mention by name.</div>
      </div>
      <div style={{ borderTop:'1px solid rgba(14,14,35,0.15)', marginTop:6, paddingTop:4 }}>
        <div style={{ fontSize:4, fontWeight:900, color:'#0E0E23' }}>Amelia Ross</div>
        <div style={{ fontSize:3.5, opacity:0.6 }}>Kindred Studios</div>
      </div>
    </div>
  </div>
);

export const TESTIMONIALS_SHAPE_BY_ID = {
  't-single': TSingle, 't-three-up': TThreeUp, 't-image': TImage, 't-marquee': TMarquee,
  't-cta': TCta, 't-quote-portrait': TQuotePortrait, 't-author-cards': TAuthorCards,
  // Iter 189c Phase B — new premium Testimonials variants
  't-wall-of-love':    TWallOfLove,
  't-interview-hero':  TInterviewHero,
};

// ════════════════════ CONTACT (8) ════════════════════
const ContactCentered = () => (
  <div style={{ background:'#FAF6EE', padding:12, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ background:'#fff', padding:10, borderRadius:5, boxShadow:'0 4px 12px rgba(0,0,0,0.06)' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Get In Touch</div>
      <div style={{ marginTop:5, display:'grid', gridTemplateColumns:'1fr 1fr', gap:3 }}>
        <div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/><div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/>
      </div>
      <div style={{ background:'#F8FAFC', height:18, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>SEND</div>
    </div>
  </div>
);
const ContactPhotoOverlay = () => (
  <div style={{ position:'relative', width:'100%', height:'100%', overflow:'hidden' }}>
    <img src={IMG.studio} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
    <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.7) 100%)' }}/>
    <div style={{ position:'absolute', bottom:8, left:10, right:10, color:'#fff' }}>
      <div style={{ fontSize:11, fontWeight:900 }}>Let&rsquo;s Talk</div>
      <div style={{ background:'#fff', padding:5, borderRadius:3, marginTop:4 }}>
        <div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/>
        <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>SEND</div>
      </div>
    </div>
  </div>
);
const ContactSplitAside = () => (
  <div style={{ display:'flex', width:'100%', height:'100%' }}>
    <div style={{ flex:1, padding:8, background:'#fff' }}>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Get In Touch</div>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:4 }}/>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#F8FAFC', height:14, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>SEND</div>
    </div>
    <img src={IMG.studio} alt="" style={{ width:'45%', height:'100%', objectFit:'cover' }}/>
  </div>
);
const ContactMapTop = () => (
  <div style={{ display:'flex', flexDirection:'column', width:'100%', height:'100%' }}>
    <div style={{ flex:1, background:'linear-gradient(180deg, #DBEAFE 0%, #BFDBFE 100%)', position:'relative' }}>
      {[0.2, 0.5, 0.7].map((y,i)=>(<div key={i} style={{ position:'absolute', left:`${i*30+15}%`, top:`${y*100}%`, width:6, height:6, background:'#EF4444', borderRadius:999, border:'1px solid #fff', boxShadow:'0 0 4px rgba(0,0,0,0.3)' }}/>))}
    </div>
    <div style={{ flex:1, padding:8, background:'#fff' }}>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Drop Us a Line</div>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:4 }}/>
      <div style={{ background:'#F8FAFC', height:14, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>SEND</div>
    </div>
  </div>
);
const ContactChips = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Get In Touch with Us</div>
    <div style={{ background:'#F8FAFC', height:24, borderRadius:3, marginTop:5 }}/>
    <div style={{ display:'flex', gap:3, flexWrap:'wrap', marginTop:5 }}>
      {[{i:'📧',t:'hello@you'},{i:'📞',t:'(555) 123'},{i:'📍',t:'NYC'}].map((c,i)=>(
        <div key={i} style={{ display:'flex', alignItems:'center', gap:2, background:'#F1F5F9', padding:'3px 6px', borderRadius:999, fontSize:5, color:'#0E0E23', fontWeight:800 }}>
          <span>{c.i}</span><span>{c.t}</span>
        </div>
      ))}
    </div>
  </div>
);
const ContactMapRight = () => (
  <div style={{ display:'flex', width:'100%', height:'100%' }}>
    <div style={{ flex:1, padding:8, background:'#fff' }}>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>You Can Mail Us</div>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:4 }}/>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#F8FAFC', height:14, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>SEND</div>
    </div>
    <div style={{ flex:1, background:'linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%)', position:'relative' }}>
      <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:10, height:10, background:'#EF4444', borderRadius:999, border:'2px solid #fff', boxShadow:'0 0 5px rgba(0,0,0,0.3)' }}/>
    </div>
  </div>
);
const ContactDarkMini = () => (
  <div style={{ background:'#0B0F1A', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', color:'#fff' }}>
    <div style={{ fontSize:8, fontWeight:900 }}>For any questions please mail us</div>
    <div style={{ marginTop:8, display:'flex', gap:3 }}>
      <div style={{ flex:1, background:'rgba(255,255,255,0.1)', height:10, borderRadius:3, paddingLeft:5, fontSize:5, color:'rgba(255,255,255,0.5)', display:'flex', alignItems:'center' }}>your@email.com</div>
      <div style={{ background:'#F97316', color:'#fff', fontSize:5, fontWeight:900, padding:'0 8px', borderRadius:3, display:'flex', alignItems:'center' }}>SEND</div>
    </div>
  </div>
);
const ContactTwoColInfoCard = () => (
  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', width:'100%', height:'100%', gap:5, padding:5, background:'#fff' }}>
    <div style={{ background:'#F8FAFC', padding:6, borderRadius:3 }}>
      <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>You Can Mail Us</div>
      <div style={{ background:'#fff', height:5, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#fff', height:12, borderRadius:2, marginTop:2 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:4, fontWeight:900, padding:'2px 0', borderRadius:2, textAlign:'center', marginTop:2 }}>SEND</div>
    </div>
    <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
      <div style={{ background:'#0E0E23', color:'#fff', padding:5, borderRadius:3 }}>
        <div style={{ fontSize:4, opacity:0.7, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>Address</div>
        <div style={{ fontSize:5, marginTop:1 }}>123 Main St, Toronto</div>
      </div>
      <div style={{ flex:1, background:'linear-gradient(135deg, #DBEAFE, #BFDBFE)', borderRadius:3, position:'relative' }}>
        <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:6, height:6, background:'#EF4444', borderRadius:999, border:'1px solid #fff' }}/>
      </div>
    </div>
  </div>
);

// Iter 189c Phase B — chat-widget-style invite miniature
const ContactChatInvite = () => (
  <div style={{ background:'#FAF6EE', padding:8, width:'100%', height:'100%', display:'flex', gap:6 }}>
    <div style={{ flex:1, background:'#fff', borderRadius:4, padding:5, boxShadow:'0 2px 6px rgba(0,0,0,0.06)' }}>
      <div style={{ display:'flex', alignItems:'center', gap:3, borderBottom:'1px solid #0E0E2310', paddingBottom:3 }}>
        <div style={{ width:4, height:4, borderRadius:999, background:'#22c55e' }} />
        <div style={{ fontSize:3.5, fontWeight:900, color:'#0E0E23' }}>ONLINE</div>
      </div>
      <div style={{ marginTop:4, background:'#F1F5F9', borderRadius:6, borderBottomLeftRadius:2, padding:'3px 5px', fontSize:4, color:'#0E0E23', maxWidth:'75%' }}>Hi! How can we help?</div>
      <div style={{ marginTop:3, marginLeft:'auto', background:'#8B5CF6', color:'#fff', borderRadius:6, borderBottomRightRadius:2, padding:'3px 5px', fontSize:4, maxWidth:'75%', textAlign:'right' }}>Need a quote.</div>
      <div style={{ marginTop:3, background:'#F1F5F9', borderRadius:6, borderBottomLeftRadius:2, padding:'3px 5px', fontSize:4, color:'#0E0E23', maxWidth:'85%' }}>Drop your details ↓</div>
    </div>
    <div style={{ flex:1, background:'#fff', borderRadius:4, padding:6, boxShadow:'0 2px 6px rgba(0,0,0,0.06)' }}>
      <div style={{ fontSize:3.5, fontWeight:900, color:'#8B5CF6', letterSpacing:0.8 }}>START</div>
      <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Send us a message</div>
      <div style={{ background:'#F1F5F9', height:5, marginTop:3, borderRadius:1 }} />
      <div style={{ background:'#F1F5F9', height:5, marginTop:2, borderRadius:1 }} />
      <div style={{ background:'#F1F5F9', height:12, marginTop:2, borderRadius:1 }} />
      <div style={{ background:'#8B5CF6', color:'#fff', fontSize:4, fontWeight:900, textAlign:'center', padding:'3px 0', marginTop:3, borderRadius:999 }}>SEND</div>
    </div>
  </div>
);

export const CONTACT_SHAPE_BY_ID = {
  'contact-centered': ContactCentered, 'contact-photo-overlay': ContactPhotoOverlay,
  'contact-split-aside': ContactSplitAside, 'contact-map-top': ContactMapTop,
  'contact-chips': ContactChips, 'contact-map-right': ContactMapRight,
  'contact-dark-mini': ContactDarkMini, 'contact-two-col-info-card': ContactTwoColInfoCard,
  // Iter 189c Phase B — new premium Contact variant
  'contact-chat-invite': ContactChatInvite,
};

// ════════════════════ FOOTER (8) ════════════════════
const FooterMinimal = () => (
  <div style={{ background:'#fff', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23' }}>Your Brand</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:3 }}>Crafted with care.</div>
    <div style={{ display:'flex', gap:5, marginTop:6 }}>
      {['🌐','📷','🐦'].map((s,i)=>(<div key={i} style={{ width:10, height:10, borderRadius:999, background:'#F1F5F9', display:'flex', alignItems:'center', justifyContent:'center', fontSize:5 }}>{s}</div>))}
    </div>
    <div style={{ fontSize:4, color:'#CBD5E1', marginTop:5 }}>© 2026 Your Brand</div>
  </div>
);
const FooterMultiCol = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr 1fr 1fr', gap:5 }}>
      <div>
        <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Your Brand</div>
        <div style={{ fontSize:4, color:'#94A3B8', marginTop:2 }}>Crafted with care.</div>
      </div>
      {['Shop','About','Help'].map((h,i)=>(
        <div key={i}>
          <div style={{ fontSize:5, fontWeight:900, color:'#0E0E23', letterSpacing:0.6, textTransform:'uppercase' }}>{h}</div>
          {[1,2,3].map(k=>(<L key={k} w={`${60-k*10}%`} mt={3} c="#CBD5E1" op={0.7}/>))}
        </div>
      ))}
    </div>
    <div style={{ borderTop:'1px solid #E2E8F0', marginTop:6, paddingTop:4, fontSize:4, color:'#CBD5E1', textAlign:'center' }}>© 2026 Your Brand</div>
  </div>
);
const FooterDark = () => (
  <div style={{ background:'#0B0F1A', padding:8, width:'100%', height:'100%', color:'#fff' }}>
    <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr 1fr 1fr', gap:5 }}>
      <div>
        <div style={{ fontSize:7, fontWeight:900 }}>Your Brand</div>
        <div style={{ fontSize:4, opacity:0.5, marginTop:2 }}>Crafted with care.</div>
      </div>
      {['Shop','About','Help'].map((h,i)=>(
        <div key={i}>
          <div style={{ fontSize:5, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase', opacity:0.7 }}>{h}</div>
          {[1,2,3].map(k=>(<L key={k} w={`${60-k*10}%`} mt={3} c="#fff" op={0.3}/>))}
        </div>
      ))}
    </div>
    <div style={{ borderTop:'1px solid rgba(255,255,255,0.1)', marginTop:6, paddingTop:4, fontSize:4, opacity:0.4, textAlign:'center' }}>© 2026 Your Brand</div>
  </div>
);
const FooterNewsletter = () => (
  <div style={{ background:'linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23' }}>Join our community</div>
    <div style={{ fontSize:5, color:'#475569', marginTop:3 }}>Get our weekly drops</div>
    <div style={{ marginTop:6, display:'flex', gap:3, width:'80%' }}>
      <div style={{ flex:1, background:'#fff', height:11, borderRadius:3, paddingLeft:4, fontSize:5, color:'#94A3B8', display:'flex', alignItems:'center' }}>you@email.com</div>
      <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'0 6px', borderRadius:3, display:'flex', alignItems:'center' }}>JOIN</div>
    </div>
  </div>
);
const FooterCtaBar = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', display:'flex', flexDirection:'column' }}>
    <div style={{ background:'#F97316', padding:10, color:'#fff', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
      <div style={{ fontSize:9, fontWeight:900 }}>Ready to get started?</div>
      <div style={{ background:'#fff', color:'#F97316', fontSize:6, fontWeight:900, padding:'3px 7px', borderRadius:3 }}>GET STARTED</div>
    </div>
    <div style={{ flex:1, padding:10, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Your Brand</div>
    </div>
  </div>
);
const FooterSlim = () => (
  <div style={{ background:'#0B0F1A', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', color:'#fff' }}>
    <div style={{ fontSize:8, fontWeight:900 }}>Your Brand</div>
    <div style={{ fontSize:5, opacity:0.5 }}>© 2026 · All rights reserved</div>
    <div style={{ display:'flex', gap:4 }}>
      {['🌐','📷','🐦'].map((s,i)=>(<div key={i} style={{ fontSize:6 }}>{s}</div>))}
    </div>
  </div>
);
const FooterListCompact = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Your Brand</div>
    <div style={{ fontSize:4, color:'#94A3B8' }}>Crafted with care.</div>
    <div style={{ display:'flex', gap:8, marginTop:6, flexWrap:'wrap' }}>
      {['Shop','About','Help','Privacy','Terms','Contact'].map((l,i)=>(
        <div key={i} style={{ fontSize:5, color:'#475569', fontWeight:700 }}>{l}</div>
      ))}
    </div>
    <div style={{ borderTop:'1px solid #E2E8F0', marginTop:6, paddingTop:3, fontSize:4, color:'#CBD5E1' }}>© 2026</div>
  </div>
);
const FooterNavSocial = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Your Brand</div>
      <div style={{ display:'flex', gap:6 }}>
        {['Shop','About','Help','Contact'].map((l,i)=>(<div key={i} style={{ fontSize:5, color:'#475569', fontWeight:700 }}>{l}</div>))}
      </div>
    </div>
    <div style={{ borderTop:'1px solid #E2E8F0', marginTop:7, paddingTop:5, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <div style={{ fontSize:4, color:'#CBD5E1' }}>© 2026 Your Brand</div>
      <div style={{ display:'flex', gap:4 }}>
        {['IG','TW','FB','YT'].map((s,i)=>(<div key={i} style={{ width:10, height:10, borderRadius:999, background:'#0E0E23', color:'#fff', fontSize:4, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center' }}>{s}</div>))}
      </div>
    </div>
  </div>
);

// Iter 189c Phase B — mega-menu editorial footer miniature
const FooterMegaMenu = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:8, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1.4fr 2fr', gap:5 }}>
    <div>
      <div style={{ fontSize:6, fontWeight:900 }}>Your Brand</div>
      <div style={{ background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:3, marginTop:3, overflow:'hidden' }}>
        <img src={IMG.studio} alt="" style={{ width:'100%', aspectRatio:'16/10', objectFit:'cover' }} />
        <div style={{ padding:3 }}>
          <div style={{ fontSize:3, color:'#F0ABFC', fontWeight:900, letterSpacing:0.8 }}>JOURNAL</div>
          <div style={{ fontSize:4, fontWeight:900, marginTop:1, lineHeight:1.2 }}>State of commerce 2026</div>
        </div>
      </div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:4 }}>
      {['Product','Company','Resources','Legal'].map((h,i)=>(
        <div key={i}>
          <div style={{ fontSize:3.5, opacity:0.7, fontWeight:900, letterSpacing:0.8 }}>{h}</div>
          {[1,2,3,4].map(j=>(<div key={j} style={{ background:'rgba(255,255,255,0.15)', height:1.5, marginTop:2, borderRadius:1 }} />))}
        </div>
      ))}
    </div>
  </div>
);

export const FOOTER_SHAPE_BY_ID = {
  'footer-minimal': FooterMinimal, 'footer-multi-column': FooterMultiCol, 'footer-dark': FooterDark,
  'footer-newsletter': FooterNewsletter, 'footer-cta-bar': FooterCtaBar, 'footer-slim': FooterSlim,
  'footer-list-compact': FooterListCompact, 'footer-nav-social': FooterNavSocial,
  // Iter 189c Phase B
  'footer-mega-menu': FooterMegaMenu,
};

// ════════════════════ FAQ (3) ════════════════════
const FaqAccordion = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center', marginBottom:6 }}>Frequently asked questions</div>
    {[true,false,false,false].map((open,i)=>(
      <div key={i} style={{ borderBottom:'1px solid #E2E8F0', padding:'4px 0' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:6, fontWeight:800, color:'#0E0E23' }}>Question {i+1}</div>
          <div style={{ fontSize:7, color:'#94A3B8', fontWeight:900 }}>{open?'−':'+'}</div>
        </div>
        {open && <L w="92%" mt={3}/>}
      </div>
    ))}
  </div>
);
const FaqTwoColumn = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center', marginBottom:5 }}>Your questions answered</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
      {[1,2,3,4].map(i=>(
        <div key={i}>
          <div style={{ fontSize:5, fontWeight:900, color:'#8B5CF6' }}>Q{i}.</div>
          <div style={{ fontSize:5, fontWeight:800, color:'#0E0E23', marginTop:1 }}>Question {i}?</div>
          <L w="80%" mt={2}/>
        </div>
      ))}
    </div>
  </div>
);
const FaqNumbered = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:5, fontWeight:900, letterSpacing:1, color:'#8B5CF6', textTransform:'uppercase' }}>How It Works</div>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', marginTop:2 }}>Easy steps to get started</div>
    <div style={{ marginTop:6 }}>
      {[1,2,3].map(i=>(
        <div key={i} style={{ display:'flex', gap:6, alignItems:'flex-start', marginTop:3 }}>
          <div style={{ width:12, height:12, borderRadius:999, background:'#0E0E23', color:'#fff', fontSize:6, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{i}</div>
          <div>
            <div style={{ fontSize:5, fontWeight:800, color:'#0E0E23' }}>Step {i}</div>
            <L w="60%" mt={1}/>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Iter 189c Phase B — searchable/help-center-style FAQ miniature
const FaqSearchable = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:4, letterSpacing:1.2, color:'#8B5CF6', fontWeight:900, textAlign:'center' }}>HELP CENTER</div>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center', marginTop:1 }}>How can we help?</div>
    <div style={{ margin:'5px auto', background:'#fff', borderRadius:999, padding:'3px 6px', display:'flex', alignItems:'center', gap:4, width:'85%', border:'1px solid #0E0E2315', boxShadow:'0 2px 8px rgba(0,0,0,0.05)' }}>
      <div style={{ opacity:0.5, fontSize:5 }}>🔍</div>
      <div style={{ flex:1, fontSize:4, color:'#94A3B8' }}>Search &ldquo;how do I…&rdquo;</div>
      <div style={{ background:'#0E0E2308', fontSize:3.5, fontWeight:900, padding:'1px 3px', borderRadius:2, color:'#94A3B8' }}>⌘K</div>
    </div>
    <div style={{ display:'flex', gap:3, justifyContent:'center', flexWrap:'wrap', marginTop:3 }}>
      {['All','Start','Billing','Account'].map((c,i)=>(
        <div key={i} style={{ background:i===0?'#8B5CF6':'#0E0E2308', color:i===0?'#fff':'#0E0E23', fontSize:3.5, fontWeight:900, padding:'2px 6px', borderRadius:999, textTransform:'uppercase', letterSpacing:0.5 }}>{c}</div>
      ))}
    </div>
    <div style={{ marginTop:5, display:'flex', flexDirection:'column', gap:2 }}>
      {['How do I create my first site?','Payment methods supported?','Can I use a custom domain?'].map((q,i)=>(
        <div key={i} style={{ background:'#fff', padding:'4px 6px', borderRadius:3, border:'1px solid #0E0E2310', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:4, fontWeight:900, color:'#0E0E23' }}>{q}</div>
          <div style={{ fontSize:6, color:'#94A3B8' }}>+</div>
        </div>
      ))}
    </div>
  </div>
);

export const FAQ_SHAPE_BY_ID = {
  'faq-accordion': FaqAccordion, 'faq-two-column': FaqTwoColumn, 'faq-numbered': FaqNumbered,
  // Iter 189c Phase B
  'faq-searchable': FaqSearchable,
};

// ════════════════════ AUTH (6) ════════════════════
const AuthSignupCard = () => (
  <div style={{ background:'#F8FAFC', padding:10, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
    <div style={{ background:'#fff', padding:10, borderRadius:5, boxShadow:'0 4px 14px rgba(0,0,0,0.06)', width:'80%' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Create an Account</div>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:5 }}/>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>SIGN UP</div>
      <div style={{ fontSize:4, color:'#94A3B8', textAlign:'center', marginTop:3 }}>Already a member? Sign In</div>
    </div>
  </div>
);
const AuthSigninCard = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
    <div style={{ background:'#fff', padding:10, borderRadius:5, boxShadow:'0 4px 14px rgba(0,0,0,0.06)', width:'75%' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Sign In</div>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:5 }}/>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>SIGN IN</div>
      <div style={{ fontSize:4, color:'#94A3B8', textAlign:'center', marginTop:3 }}>Forgot password?</div>
    </div>
  </div>
);
const AuthSignupSplit = () => (
  <div style={{ display:'flex', width:'100%', height:'100%' }}>
    <div style={{ flex:1, padding:10, background:'#fff', display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Sign up to discover features</div>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:4 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:2 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:2 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>GET STARTED</div>
    </div>
    <img src={IMG.art} alt="" style={{ width:'45%', height:'100%', objectFit:'cover' }}/>
  </div>
);
const AuthSignupMountain = () => (
  <div style={{ position:'relative', width:'100%', height:'100%' }}>
    <img src={IMG.mount} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
    <div style={{ position:'absolute', right:6, top:'50%', transform:'translateY(-50%)', background:'#fff', padding:8, borderRadius:5, width:'46%', boxShadow:'0 4px 12px rgba(0,0,0,0.15)' }}>
      <div style={{ fontSize:5, fontWeight:900, color:'#8B5CF6', letterSpacing:0.6, textTransform:'uppercase' }}>Sign Up Now</div>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginTop:2, lineHeight:1.1 }}>Easy to setup.</div>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#F8FAFC', height:6, borderRadius:2, marginTop:2 }}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>GET STARTED</div>
    </div>
  </div>
);
const AuthPaymentMethod = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Choose Your Payment Method</div>
    <div style={{ display:'flex', gap:3, marginTop:4 }}>
      {['VISA','MC','AMEX','PP'].map((b,i)=>(<div key={i} style={{ flex:1, background:i===0?'#E0E7FF':'#F8FAFC', padding:3, borderRadius:3, textAlign:'center', fontSize:5, fontWeight:900, color:i===0?'#3730A3':'#94A3B8', border:i===0?'1.5px solid #6366F1':'1px solid #E2E8F0' }}>{b}</div>))}
    </div>
    <div style={{ background:'#F8FAFC', height:9, borderRadius:2, marginTop:4 }}/>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:3, marginTop:3 }}>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/>
    </div>
    <div style={{ background:'#10B981', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 0', borderRadius:2, textAlign:'center', marginTop:5 }}>PAY SECURELY 🔒</div>
  </div>
);
const AuthBilling = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Create Billing Account</div>
    <div style={{ marginTop:5, display:'grid', gridTemplateColumns:'1fr 1fr', gap:3 }}>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
    </div>
    <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:3 }}/>
    <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:3 }}/>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3, marginTop:3 }}>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
    </div>
    <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>SAVE ACCOUNT</div>
  </div>
);

export const AUTH_SHAPE_BY_ID = {
  'auth-signup-card': AuthSignupCard, 'auth-signin-card': AuthSigninCard,
  'auth-signup-split': AuthSignupSplit, 'auth-signup-mountain': AuthSignupMountain,
  'auth-payment-method': AuthPaymentMethod, 'auth-billing': AuthBilling,
};

// ════════════════════ DONATIONS (5) ════════════════════
const DonTiers = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Support Our Mission</div>
    <div style={{ fontSize:5, color:'#94A3B8', textAlign:'center', marginTop:1 }}>Every gift counts</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:3, marginTop:5 }}>
      {[25,50,100,250].map((a,i)=>(<div key={i} style={{ background:'#fff', padding:6, borderRadius:3, textAlign:'center', border:i===1?'2px solid #EC4899':'1px solid #E2E8F0' }}>
        <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23' }}>${a}</div>
      </div>))}
    </div>
    <div style={{ background:'#EC4899', color:'#fff', fontSize:6, fontWeight:900, padding:'4px 0', borderRadius:3, textAlign:'center', marginTop:4 }}>DONATE NOW ♥</div>
  </div>
);
const DonStory = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', display:'flex' }}>
    <img src={IMG.team} alt="" style={{ width:'45%', height:'100%', objectFit:'cover' }}/>
    <div style={{ flex:1, padding:10, display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Why We Exist</div>
      <L w="90%" mt={3}/><L w="80%" mt={2}/>
      <div style={{ display:'flex', gap:3, marginTop:5 }}>
        {[10,50,100].map(a=>(<div key={a} style={{ flex:1, background:'#F8FAFC', padding:3, borderRadius:2, textAlign:'center', fontSize:6, fontWeight:900, color:'#0E0E23' }}>${a}</div>))}
      </div>
    </div>
  </div>
);
const DonMonthly = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:12, width:'100%', height:'100%' }}>
    <Chip c="#F97316">Monthly Giving</Chip>
    <div style={{ fontSize:9, fontWeight:900, marginTop:4 }}>Become a Monthly Supporter</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:3, marginTop:5 }}>
      {[5,15,30,50].map((a,i)=>(<div key={a} style={{ background:i===1?'#F97316':'rgba(255,255,255,0.08)', padding:5, borderRadius:3, textAlign:'center' }}>
        <div style={{ fontSize:8, fontWeight:900 }}>${a}</div>
        <div style={{ fontSize:4, opacity:0.7 }}>/mo</div>
      </div>))}
    </div>
  </div>
);
const DonImpact = () => (
  <div style={{ background:'#FAF6EE', padding:12, width:'100%', height:'100%', textAlign:'center', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ fontSize:18, fontWeight:900, color:'#EC4899' }}>12,000</div>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23', letterSpacing:1, textTransform:'uppercase', marginTop:1 }}>Lives impacted</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:3 }}>And counting.</div>
    <div style={{ background:'#EC4899', color:'#fff', fontSize:6, fontWeight:900, padding:'4px 0', borderRadius:3, marginTop:6, marginLeft:'auto', marginRight:'auto', width:'70%' }}>GIVE NOW</div>
  </div>
);
const DonThanks = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Thank you to our supporters</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3, marginTop:5 }}>
      {['Anna L.','Marcus P.','Jordan S.','Sarah K.','Alex T.','Lena R.','Pat F.','Diego M.','Maya O.'].map((n,i)=>(
        <div key={i} style={{ background:i%2?'#F8FAFC':'#FAF6EE', padding:'3px 5px', borderRadius:2, fontSize:5, fontWeight:800, color:'#0E0E23', textAlign:'center' }}>{n}</div>
      ))}
    </div>
  </div>
);

export const DONATIONS_SHAPE_BY_ID = {
  'don-tiers': DonTiers, 'don-story': DonStory, 'don-monthly': DonMonthly,
  'don-impact': DonImpact, 'don-thanks': DonThanks,
};

// ════════════════════ VIDEOS (5) ════════════════════
const VHero = () => (
  <div style={{ position:'relative', width:'100%', height:'100%' }}>
    <img src={IMG.city} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.35)' }}/>
    <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:30, height:30, borderRadius:999, background:'rgba(255,255,255,0.95)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 4px 14px rgba(0,0,0,0.3)' }}>
      <div style={{ width:0, height:0, borderLeft:'10px solid #0E0E23', borderTop:'7px solid transparent', borderBottom:'7px solid transparent', marginLeft:3 }}/>
    </div>
  </div>
);
const VGrid = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr', gridTemplateRows:'1fr 1fr', gap:4 }}>
    {[IMG.city, IMG.studio, IMG.team, IMG.art].map((s,i)=>(
      <div key={i} style={{ position:'relative', borderRadius:3, overflow:'hidden' }}>
        <img src={s} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
        <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:14, height:14, borderRadius:999, background:'rgba(255,255,255,0.9)', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ width:0, height:0, borderLeft:'5px solid #0E0E23', borderTop:'3px solid transparent', borderBottom:'3px solid transparent', marginLeft:1 }}/>
        </div>
      </div>
    ))}
  </div>
);
const VEmbed = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ background:'#000', borderRadius:3, position:'relative', height:'70%', overflow:'hidden' }}>
      <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:24, height:24, borderRadius:999, background:'#EF0000', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ width:0, height:0, borderLeft:'8px solid #fff', borderTop:'5px solid transparent', borderBottom:'5px solid transparent', marginLeft:2 }}/>
      </div>
      <div style={{ position:'absolute', bottom:2, left:2, right:2, height:2, background:'rgba(255,255,255,0.3)', borderRadius:1 }}>
        <div style={{ width:'40%', height:'100%', background:'#EF0000', borderRadius:1 }}/>
      </div>
    </div>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Watch our story</div>
  </div>
);
const VTestimonial = () => (
  <div style={{ background:'#0E0E23', width:'100%', height:'100%', display:'flex', alignItems:'center', padding:10 }}>
    <div style={{ position:'relative', width:36, height:36, borderRadius:999, overflow:'hidden' }}>
      <img src={IMG.port3} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
      <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.3)' }}/>
      <div style={{ position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)', width:0, height:0, borderLeft:'8px solid #fff', borderTop:'5px solid transparent', borderBottom:'5px solid transparent', marginLeft:2 }}/>
    </div>
    <div style={{ flex:1, marginLeft:8, color:'#fff' }}>
      <div style={{ fontSize:5, opacity:0.5, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>Customer Story</div>
      <L w="80%" mt={3} c="#fff" op={0.6}/><L w="60%" mt={2} c="#fff" op={0.4}/>
    </div>
  </div>
);
const VBanner = () => (
  <div style={{ position:'relative', width:'100%', height:'100%' }}>
    <img src={IMG.beach} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
    <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.7) 100%)' }}/>
    <div style={{ position:'absolute', left:8, bottom:6, color:'#fff' }}>
      <Chip c="#fff" fg="#0E0E23">▶ FEATURED</Chip>
      <div style={{ fontSize:9, fontWeight:900, marginTop:4 }}>Cinematic banner</div>
    </div>
  </div>
);

export const VIDEOS_SHAPE_BY_ID = {
  'v-hero': VHero, 'v-grid': VGrid, 'v-embed': VEmbed, 'v-testimonial': VTestimonial, 'v-banner': VBanner,
};

// ════════════════════ FORMS (5) ════════════════════
const FContact = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Get in touch</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:3, marginTop:4 }}>
      <div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/><div style={{ background:'#F8FAFC', height:8, borderRadius:2 }}/>
    </div>
    <div style={{ background:'#F8FAFC', height:8, borderRadius:2, marginTop:3 }}/>
    <div style={{ background:'#F8FAFC', height:16, borderRadius:2, marginTop:3 }}/>
    <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>SEND</div>
  </div>
);
const FQuote = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Request a Quote</div>
    <div style={{ background:'#fff', height:8, borderRadius:2, marginTop:4 }}/>
    <div style={{ background:'#fff', height:8, borderRadius:2, marginTop:3 }}/>
    <div style={{ display:'flex', gap:3, marginTop:3 }}>
      {['Project','Budget','Timeline'].map((t,i)=>(<div key={i} style={{ flex:1, background:'#fff', height:7, borderRadius:2, paddingLeft:2, fontSize:4, color:'#94A3B8', display:'flex', alignItems:'center' }}>{t}</div>))}
    </div>
    <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:4 }}>GET QUOTE</div>
  </div>
);
const FFeedback = () => (
  <div style={{ background:'#fff', padding:12, width:'100%', height:'100%', textAlign:'center' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Tell us what you think</div>
    <div style={{ display:'flex', gap:4, justifyContent:'center', marginTop:6 }}>
      {['😞','😐','🙂','😀','🤩'].map((e,i)=>(<div key={i} style={{ width:18, height:18, borderRadius:999, background:i===3?'#FCD34D':'#F1F5F9', display:'flex', alignItems:'center', justifyContent:'center', fontSize:9 }}>{e}</div>))}
    </div>
    <div style={{ background:'#F8FAFC', height:18, borderRadius:2, marginTop:5 }}/>
    <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 8px', borderRadius:2, marginTop:4, display:'inline-block' }}>SUBMIT</div>
  </div>
);
const FRsvp = () => (
  <div style={{ background:'#FAF6EE', padding:12, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>RSVP</div>
    <div style={{ display:'flex', gap:4, marginTop:5 }}>
      <div style={{ flex:1, background:'#10B981', color:'#fff', padding:5, borderRadius:3, textAlign:'center', fontSize:6, fontWeight:900 }}>✓ YES</div>
      <div style={{ flex:1, background:'#F1F5F9', color:'#475569', padding:5, borderRadius:3, textAlign:'center', fontSize:6, fontWeight:900 }}>✗ NO</div>
      <div style={{ flex:1, background:'#F1F5F9', color:'#475569', padding:5, borderRadius:3, textAlign:'center', fontSize:6, fontWeight:900 }}>? MAYBE</div>
    </div>
    <div style={{ background:'#fff', height:8, borderRadius:2, marginTop:4 }}/>
    <div style={{ background:'#fff', height:8, borderRadius:2, marginTop:2 }}/>
  </div>
);
const FSurvey = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:5, color:'#94A3B8', fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>Question 1 of 5</div>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginTop:3 }}>How likely are you to recommend us?</div>
    <div style={{ marginTop:5 }}>
      {[1,2,3,4].map(i=>(
        <div key={i} style={{ display:'flex', alignItems:'center', gap:5, padding:'3px 0' }}>
          <div style={{ width:8, height:8, borderRadius:999, background:i===2?'#8B5CF6':'#fff', border:'1.5px solid #8B5CF6' }}/>
          <L w={`${70-i*10}%`} mt={0}/>
        </div>
      ))}
    </div>
  </div>
);

// Iter 189c Phase B — multi-step wizard miniature
const FMultiStep = () => (
  <div style={{ background:'#FAF6EE', padding:8, width:'100%', height:'100%' }}>
    <div style={{ textAlign:'center' }}>
      <div style={{ fontSize:3.5, color:'#8B5CF6', fontWeight:900, letterSpacing:0.8 }}>STEP-BY-STEP</div>
      <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Tell us about your project</div>
    </div>
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:5 }}>
      {[0,1,2,3].map(i=>(
        <React.Fragment key={i}>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
            <div style={{ width:12, height:12, borderRadius:999, background:i<2?'#8B5CF6':'#fff', color:i<2?'#fff':'#0E0E23', border:i<2?'none':'1px solid #0E0E2330', fontSize:5, fontWeight:900, display:'flex', alignItems:'center', justifyContent:'center' }}>{i<1?'✓':i+1}</div>
            <div style={{ fontSize:3, fontWeight:900, marginTop:1, opacity:i===1?1:0.5 }}>{['Info','Project','Budget','Review'][i]}</div>
          </div>
          {i<3 && <div style={{ flex:1, height:1, background:i<1?'#8B5CF6':'#0E0E2320', marginTop:-5 }} />}
        </React.Fragment>
      ))}
    </div>
    <div style={{ marginTop:5, background:'#fff', padding:6, borderRadius:4, boxShadow:'0 2px 8px rgba(0,0,0,0.05)', border:'1px solid #0E0E2310' }}>
      <div style={{ fontSize:3, color:'#8B5CF6', fontWeight:900, letterSpacing:0.5 }}>STEP 2 OF 4</div>
      <div style={{ fontSize:5, fontWeight:900, color:'#0E0E23' }}>Project</div>
      <div style={{ background:'#F1F5F9', height:5, marginTop:3, borderRadius:1 }} />
      <div style={{ background:'#F1F5F9', height:5, marginTop:2, borderRadius:1 }} />
      <div style={{ marginTop:4, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ fontSize:3, opacity:0.5 }}>&larr; Back</div>
        <div style={{ background:'#8B5CF6', color:'#fff', fontSize:3.5, fontWeight:900, padding:'2px 6px', borderRadius:999 }}>CONTINUE &rarr;</div>
      </div>
    </div>
  </div>
);

export const FORMS_SHAPE_BY_ID = {
  'f-contact': FContact, 'f-quote': FQuote, 'f-feedback': FFeedback, 'f-rsvp': FRsvp, 'f-survey': FSurvey,
  // Iter 189c Phase B
  'f-multi-step': FMultiStep,
};

// ════════════════════ NEWSLETTER (5) ════════════════════
const NInline = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23' }}>Stay in the loop</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:2 }}>Get updates monthly</div>
    <div style={{ display:'flex', gap:3, marginTop:5, width:'80%' }}>
      <div style={{ flex:1, background:'#fff', height:10, borderRadius:3, paddingLeft:4, fontSize:5, color:'#94A3B8', display:'flex', alignItems:'center' }}>you@email.com</div>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'0 8px', borderRadius:3, display:'flex', alignItems:'center' }}>JOIN</div>
    </div>
  </div>
);
const NBanner = () => (
  <div style={{ background:'linear-gradient(135deg, #8B5CF6, #EC4899)', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', color:'#fff', textAlign:'center' }}>
    <div style={{ fontSize:14, fontWeight:900 }}>Subscribe</div>
    <div style={{ fontSize:5, opacity:0.85, marginTop:2 }}>Never miss a drop</div>
    <div style={{ display:'flex', gap:3, marginTop:6, width:'85%' }}>
      <div style={{ flex:1, background:'rgba(255,255,255,0.2)', height:11, borderRadius:3, paddingLeft:5, fontSize:5, color:'rgba(255,255,255,0.7)', display:'flex', alignItems:'center' }}>you@email.com</div>
      <div style={{ background:'#fff', color:'#0E0E23', fontSize:5, fontWeight:900, padding:'0 10px', borderRadius:3, display:'flex', alignItems:'center' }}>SUBSCRIBE</div>
    </div>
  </div>
);
const NIncentive = () => (
  <div style={{ background:'#fff', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <Chip c="#10B981">▼ 10% OFF</Chip>
    <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', marginTop:4 }}>Get 10% off your first order</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:2 }}>Just enter your email</div>
    <div style={{ display:'flex', gap:3, marginTop:5, width:'80%' }}>
      <div style={{ flex:1, background:'#F8FAFC', height:10, borderRadius:3, paddingLeft:4, fontSize:5, color:'#94A3B8', display:'flex', alignItems:'center' }}>email</div>
      <div style={{ background:'#10B981', color:'#fff', fontSize:5, fontWeight:900, padding:'0 7px', borderRadius:3, display:'flex', alignItems:'center' }}>CLAIM</div>
    </div>
  </div>
);
const NFooter = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:12, width:'100%', height:'100%', display:'flex', alignItems:'center', gap:8 }}>
    <div style={{ flex:1 }}>
      <div style={{ fontSize:7, fontWeight:900 }}>Newsletter</div>
      <div style={{ fontSize:4, opacity:0.6, marginTop:1 }}>Weekly digest in your inbox</div>
    </div>
    <div style={{ display:'flex', gap:3, flex:1.5 }}>
      <div style={{ flex:1, background:'rgba(255,255,255,0.1)', height:10, borderRadius:3, paddingLeft:4, fontSize:5, color:'rgba(255,255,255,0.5)', display:'flex', alignItems:'center' }}>email</div>
      <div style={{ background:'#F97316', color:'#fff', fontSize:5, fontWeight:900, padding:'0 7px', borderRadius:3, display:'flex', alignItems:'center' }}>OK</div>
    </div>
  </div>
);
const NLaunch = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', textAlign:'center', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ fontSize:5, color:'#8B5CF6', fontWeight:900, letterSpacing:1, textTransform:'uppercase' }}>Coming Q2 2026</div>
    <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Get notified at launch</div>
    <div style={{ display:'flex', gap:3, marginTop:5, width:'80%', marginLeft:'auto', marginRight:'auto' }}>
      <div style={{ flex:1, background:'#fff', height:10, borderRadius:3, paddingLeft:4, fontSize:5, color:'#94A3B8', display:'flex', alignItems:'center' }}>you@email.com</div>
      <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'0 7px', borderRadius:3, display:'flex', alignItems:'center' }}>NOTIFY ME</div>
    </div>
  </div>
);

// Iter 189c Phase B — magazine-style inline signup miniature
const NMagazineInline = () => (
  <div style={{ background:'#FAF6EE', padding:8, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:6, alignItems:'center' }}>
    <div>
      <div style={{ fontSize:3, fontWeight:900, color:'#8B5CF6', letterSpacing:0.8 }}>ISSUE 12 · FREE MONTHLY</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:2, lineHeight:1.15 }}>Stories worth noticing.</div>
      <div style={{ fontSize:4, color:'#94A3B8', marginTop:2, lineHeight:1.35 }}>Long-form essays, studio visits, and quiet obsessions.</div>
      <div style={{ display:'flex', gap:3, marginTop:4 }}>
        <div style={{ flex:1, background:'#fff', height:9, borderRadius:3, paddingLeft:3, fontSize:4, color:'#94A3B8', display:'flex', alignItems:'center', border:'1px solid #0E0E2315' }}>you@email.com</div>
        <div style={{ background:'#0E0E23', color:'#fff', fontSize:4, fontWeight:900, padding:'0 6px', borderRadius:3, display:'flex', alignItems:'center' }}>SUBSCRIBE</div>
      </div>
    </div>
    <div style={{ position:'relative', width:'100%', aspectRatio:'3/4', borderRadius:3, overflow:'hidden', boxShadow:'0 4px 12px rgba(0,0,0,0.15)' }}>
      <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
      <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.8))', display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:3, color:'#fff' }}>
        <div style={{ fontSize:2.5, opacity:0.7, fontWeight:900, letterSpacing:0.5 }}>THIS ISSUE</div>
        <div style={{ fontSize:5, fontWeight:900, lineHeight:1.1 }}>Quiet luxury</div>
      </div>
    </div>
  </div>
);

export const NEWSLETTER_SHAPE_BY_ID = {
  'n-inline': NInline, 'n-banner': NBanner, 'n-incentive': NIncentive, 'n-footer': NFooter, 'n-launch': NLaunch,
  // Iter 189c Phase B
  'n-magazine-inline': NMagazineInline,
};

// ════════════════════ CALENDAR (5) ════════════════════
const CalMonth = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ display:'flex', justifyContent:'space-between', fontSize:6, fontWeight:900, color:'#0E0E23' }}>
      <span>‹</span><span>August 2026</span><span>›</span>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:2, marginTop:4 }}>
      {['S','M','T','W','T','F','S'].map((d,i)=>(<div key={i} style={{ fontSize:4, color:'#94A3B8', textAlign:'center', fontWeight:900 }}>{d}</div>))}
      {Array.from({length:28}).map((_,i)=>(
        <div key={i} style={{ aspectRatio:'1/1', fontSize:4, textAlign:'center', display:'flex', alignItems:'center', justifyContent:'center', borderRadius:2, background:i===12?'#8B5CF6':i===17?'#F97316':'transparent', color:[12,17].includes(i)?'#fff':'#0E0E23', fontWeight:[12,17].includes(i)?900:500 }}>{i+1}</div>
      ))}
    </div>
  </div>
);
const CalList = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Upcoming dates</div>
    {[{d:'12',m:'AUG',e:'Art Walk'},{d:'25',m:'AUG',e:'Live Show'},{d:'02',m:'SEP',e:'Workshop'}].map((it,i)=>(
      <div key={i} style={{ display:'flex', alignItems:'center', gap:6, padding:'4px 0', borderBottom:'1px solid #E2E8F0' }}>
        <div style={{ textAlign:'center', minWidth:18 }}>
          <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23' }}>{it.d}</div>
          <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900 }}>{it.m}</div>
        </div>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:6, fontWeight:800, color:'#0E0E23' }}>{it.e}</div>
          <L w="60%" mt={1}/>
        </div>
      </div>
    ))}
  </div>
);
const CalBanner = () => (
  <div style={{ background:'linear-gradient(135deg, #FBBF24, #F97316)', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', color:'#fff', textAlign:'center' }}>
    <div style={{ fontSize:5, opacity:0.85, fontWeight:900, letterSpacing:1, textTransform:'uppercase' }}>Mark your calendar</div>
    <div style={{ fontSize:14, fontWeight:900, marginTop:3 }}>Save the date · Aug 12</div>
    <div style={{ background:'rgba(255,255,255,0.25)', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 8px', borderRadius:3, marginTop:5 }}>+ ADD TO CALENDAR</div>
  </div>
);
const CalRsvp = FRsvp;
const CalFeature = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%' }}>
    <img src={IMG.studio} alt="" style={{ width:'100%', height:'55%', objectFit:'cover' }}/>
    <div style={{ padding:8 }}>
      <Chip c="#F97316">▶ FEATURED EVENT</Chip>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Featured Event</div>
      <div style={{ fontSize:5, color:'#94A3B8', marginTop:1 }}>Aug 12 · Brooklyn</div>
    </div>
  </div>
);

export const CALENDAR_SHAPE_BY_ID = {
  'cal-month': CalMonth, 'cal-list': CalList, 'cal-banner': CalBanner, 'cal-rsvp': CalRsvp, 'cal-feature': CalFeature,
};

// ════════════════════ MENUS (5) ════════════════════
const MenuList = () => (
  <div style={{ background:'#FFFBEB', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Menu</div>
    {[{n:'Wagyu Burger',p:'$18'},{n:'Tuna Tartare',p:'$22'},{n:'Truffle Pasta',p:'$28'},{n:'Crème Brûlée',p:'$12'}].map((it,i)=>(
      <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', padding:'4px 0', borderBottom:'1px dashed #D6D3D1' }}>
        <div style={{ fontSize:7, fontWeight:800, color:'#0E0E23', fontFamily:'Georgia, serif' }}>{it.n}</div>
        <div style={{ fontSize:7, fontWeight:900, color:'#D97706' }}>{it.p}</div>
      </div>
    ))}
  </div>
);
const MenuGrid = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:4 }}>Menu</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3 }}>
      {[IMG.food, IMG.food2, IMG.food, IMG.food2, IMG.food, IMG.food2].map((s,i)=>(
        <div key={i}>
          <img src={s} alt="" style={{ width:'100%', aspectRatio:'1/1', objectFit:'cover', borderRadius:3 }}/>
          <div style={{ fontSize:4, color:'#0E0E23', fontWeight:800, marginTop:1 }}>Dish {i+1}</div>
          <div style={{ fontSize:4, color:'#D97706', fontWeight:900 }}>${(i+1)*6}</div>
        </div>
      ))}
    </div>
  </div>
);
const MenuFeature = () => (
  <div style={{ background:'#0E0E23', width:'100%', height:'100%', display:'flex' }}>
    <img src={IMG.food2} alt="" style={{ width:'55%', height:'100%', objectFit:'cover' }}/>
    <div style={{ flex:1, padding:12, color:'#fff', display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <Chip c="#F97316">Chef&rsquo;s Pick</Chip>
      <div style={{ fontSize:11, fontWeight:900, marginTop:3, fontFamily:'Georgia, serif' }}>Signature Plate</div>
      <L w="80%" mt={5} c="#fff" op={0.4}/><L w="60%" mt={3} c="#fff" op={0.4}/>
    </div>
  </div>
);
const MenuPrix = () => (
  <div style={{ background:'#FAF6EE', padding:12, width:'100%', height:'100%', textAlign:'center' }}>
    <div style={{ fontSize:5, fontWeight:900, color:'#8B5CF6', letterSpacing:1, textTransform:'uppercase' }}>5 Courses</div>
    <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', fontFamily:'Georgia, serif', marginTop:3 }}>Tasting Menu</div>
    <div style={{ fontSize:14, fontWeight:900, color:'#D97706', marginTop:3 }}>$85</div>
    <div style={{ marginTop:6 }}>
      {['Amuse','Crudo','Pasta','Main','Dessert'].map((c,i)=>(<div key={i} style={{ fontSize:5, color:'#0E0E23', fontWeight:700, marginTop:2 }}>{c}</div>))}
    </div>
  </div>
);
const MenuBook = () => (
  <div style={{ background:'#fff', padding:12, width:'100%', height:'100%', textAlign:'center' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Book a Table</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:3, marginTop:6 }}>
      <div style={{ background:'#F8FAFC', padding:4, borderRadius:2, fontSize:5, color:'#0E0E23', fontWeight:800 }}>📅 Aug 12</div>
      <div style={{ background:'#F8FAFC', padding:4, borderRadius:2, fontSize:5, color:'#0E0E23', fontWeight:800 }}>🕖 7:30 PM</div>
    </div>
    <div style={{ background:'#F8FAFC', padding:4, borderRadius:2, fontSize:5, color:'#0E0E23', fontWeight:800, marginTop:3 }}>👤 Party of 4</div>
    <div style={{ background:'#D97706', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 0', borderRadius:2, marginTop:4 }}>RESERVE</div>
  </div>
);

export const MENU_SHAPE_BY_ID = {
  'menu-list': MenuList, 'menu-grid': MenuGrid, 'menu-feature': MenuFeature, 'menu-prix': MenuPrix, 'menu-book': MenuBook,
};

// ════════════════════ AUDIO (5) ════════════════════
const AuPlayer = () => (
  <div style={{ background:'linear-gradient(135deg, #1DB954, #168f3f)', padding:12, width:'100%', height:'100%', color:'#fff', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ display:'flex', alignItems:'center', gap:7 }}>
      <div style={{ width:24, height:24, borderRadius:3, background:'rgba(255,255,255,0.3)' }}/>
      <div style={{ flex:1 }}>
        <div style={{ fontSize:6, fontWeight:900 }}>Track Title</div>
        <div style={{ fontSize:4, opacity:0.8 }}>Artist Name</div>
      </div>
      <div style={{ width:18, height:18, borderRadius:999, background:'#fff', color:'#1DB954', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ width:0, height:0, borderLeft:'6px solid #1DB954', borderTop:'4px solid transparent', borderBottom:'4px solid transparent', marginLeft:1.5 }}/>
      </div>
    </div>
    <div style={{ background:'rgba(255,255,255,0.3)', height:2, borderRadius:1, marginTop:6 }}>
      <div style={{ width:'40%', height:'100%', background:'#fff', borderRadius:1 }}/>
    </div>
    <div style={{ display:'flex', justifyContent:'space-between', fontSize:4, marginTop:2, opacity:0.7 }}>
      <span>1:24</span><span>3:42</span>
    </div>
  </div>
);
const AuPlaylist = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Latest Episodes</div>
    {[1,2,3,4].map(i=>(
      <div key={i} style={{ display:'flex', alignItems:'center', gap:5, padding:'3px 0', borderBottom:'1px solid #F1F5F9' }}>
        <div style={{ width:10, height:10, borderRadius:2, background:`hsl(${i*60},60%,55%)` }}/>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:5, fontWeight:800, color:'#0E0E23' }}>Episode {i}</div>
          <div style={{ fontSize:4, color:'#94A3B8' }}>32 min</div>
        </div>
        <div style={{ fontSize:7, color:'#0E0E23' }}>▶</div>
      </div>
    ))}
  </div>
);
const AuFeature = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:12, width:'100%', height:'100%', display:'flex', alignItems:'center', gap:8 }}>
    <div style={{ width:42, height:42, borderRadius:5, background:'linear-gradient(135deg, #EC4899, #F97316)' }}/>
    <div style={{ flex:1 }}>
      <Chip c="#F97316">NEW SINGLE</Chip>
      <div style={{ fontSize:8, fontWeight:900, marginTop:3 }}>New Single</div>
      <div style={{ fontSize:4, opacity:0.7, marginTop:1 }}>Stream now everywhere</div>
      <div style={{ display:'flex', gap:3, marginTop:4 }}>
        {['Spotify','Apple','YT'].map((s,i)=>(<div key={i} style={{ fontSize:4, fontWeight:900, padding:'2px 4px', background:'rgba(255,255,255,0.1)', borderRadius:2 }}>{s}</div>))}
      </div>
    </div>
  </div>
);
const AuTour = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Tour Dates</div>
    {[{c:'New York',d:'AUG 12'},{c:'Los Angeles',d:'AUG 22'},{c:'Chicago',d:'SEP 03'}].map((it,i)=>(
      <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'4px 0', borderBottom:'1px solid #F1F5F9' }}>
        <div>
          <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>{it.c}</div>
          <div style={{ fontSize:4, color:'#94A3B8' }}>The Forum</div>
        </div>
        <div style={{ background:'#0E0E23', color:'#fff', fontSize:4, fontWeight:900, padding:'3px 6px', borderRadius:999 }}>{it.d}</div>
      </div>
    ))}
  </div>
);
const AuCta = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:12, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:4, flexWrap:'wrap' }}>
    {[{n:'Spotify',c:'#1DB954'},{n:'Apple Music',c:'#FA243C'},{n:'YouTube',c:'#FF0000'}].map((s,i)=>(
      <div key={i} style={{ background:s.c, color:'#fff', fontSize:5, fontWeight:900, padding:'4px 8px', borderRadius:999 }}>♪ {s.n}</div>
    ))}
  </div>
);

export const AUDIO_SHAPE_BY_ID = {
  'au-player': AuPlayer, 'au-playlist': AuPlaylist, 'au-feature': AuFeature, 'au-tour': AuTour, 'au-cta': AuCta,
};

// ════════════════════ CHARTS (5) ════════════════════
const ChStats = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center' }}>
    <div>
      <div style={{ fontSize:16, fontWeight:900, color:'#0E0E23' }}>500K+ <span style={{ color:'#F59E0B' }}>★ 4.9</span></div>
      <div style={{ fontSize:5, color:'#94A3B8', marginTop:3 }}>Customers · Rating</div>
    </div>
  </div>
);
const ChGrowth = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>By the Numbers</div>
    <div style={{ display:'flex', gap:4, alignItems:'flex-end', height:50, marginTop:6 }}>
      {[20,35,28,55,42,68,80].map((h,i)=>(<div key={i} style={{ flex:1, height:`${h}%`, background:i===6?'#8B5CF6':'#CBD5E1', borderRadius:'2px 2px 0 0' }}/>))}
    </div>
    <div style={{ fontSize:4, color:'#94A3B8', marginTop:3 }}>Jan ・・・ Jul</div>
  </div>
);
const ChTestimonialStat = () => (
  <div style={{ background:'#fff', padding:14, width:'100%', height:'100%', textAlign:'center', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ fontSize:18, fontWeight:900, color:'#F59E0B' }}>★ 4.9</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:1, letterSpacing:0.6 }}>ACROSS 2,400 REVIEWS</div>
    <div style={{ fontSize:7, fontFamily:'Georgia, serif', color:'#0E0E23', marginTop:5, fontStyle:'italic', lineHeight:1.3 }}>&ldquo;Best in class.&rdquo;</div>
  </div>
);
const ChBanner = () => (
  <div style={{ background:'linear-gradient(135deg, #0E0E23, #5B21B6)', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <div style={{ fontSize:20, fontWeight:900 }}>12,000+</div>
    <div style={{ fontSize:5, opacity:0.8, letterSpacing:1, textTransform:'uppercase', marginTop:1 }}>Orders Shipped</div>
  </div>
);
const ChCta = () => (
  <div style={{ background:'#10B981', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
    <div>
      <div style={{ fontSize:6, opacity:0.85, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>15K+ in our community</div>
      <div style={{ fontSize:11, fontWeight:900, marginTop:2 }}>Join the movement</div>
    </div>
    <div style={{ background:'#fff', color:'#10B981', fontSize:6, fontWeight:900, padding:'4px 8px', borderRadius:3 }}>JOIN US</div>
  </div>
);

export const CHARTS_SHAPE_BY_ID = {
  'ch-stats': ChStats, 'ch-growth': ChGrowth, 'ch-testimonial-stat': ChTestimonialStat, 'ch-banner': ChBanner, 'ch-cta': ChCta,
};

// ════════════════════ SOCIAL (5) ════════════════════
const SMarquee = () => (
  <div style={{ background:'linear-gradient(135deg, #EC4899, #F97316)', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', overflow:'hidden' }}>
    <div style={{ fontSize:14, fontWeight:900, letterSpacing:-0.3 }}>@yourhandle · INSTAGRAM · TIKTOK ·</div>
  </div>
);
const SBanner = () => (
  <div style={{ background:'#0E0E23', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:6, color:'#fff' }}>
    <div style={{ fontSize:9, fontWeight:900 }}>Follow us @yourhandle</div>
    <div style={{ display:'flex', gap:3 }}>
      {['📷','🐦','🎵'].map((s,i)=>(<div key={i} style={{ width:14, height:14, borderRadius:999, background:'rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:7 }}>{s}</div>))}
    </div>
  </div>
);
const SEmbed = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4 }}>
    {[IMG.studio, IMG.team, IMG.beach].map((s,i)=>(
      <div key={i} style={{ background:'#FFE4E6', borderRadius:3, overflow:'hidden' }}>
        <img src={s} alt="" style={{ width:'100%', aspectRatio:'1/1', objectFit:'cover' }}/>
        <div style={{ padding:3, fontSize:4, color:'#0E0E23', fontWeight:800 }}>♥ 12.4K</div>
      </div>
    ))}
  </div>
);
const SGrid = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>From the Feed @you</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gridAutoRows:'1fr', gap:2, marginTop:3 }}>
      {[IMG.studio, IMG.team, IMG.beach, IMG.mount, IMG.city, IMG.art].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:'100%', aspectRatio:'1/1', objectFit:'cover', borderRadius:2 }}/>))}
    </div>
  </div>
);
const SCta = () => (
  <div style={{ background:'linear-gradient(135deg, #FBBF24, #F472B6)', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', color:'#0E0E23', textAlign:'center' }}>
    <div style={{ fontSize:11, fontWeight:900 }}>Tag us in your photos</div>
    <div style={{ fontSize:6, fontWeight:900, marginTop:3 }}>#yourbrand · @yourhandle</div>
  </div>
);

export const SOCIAL_SHAPE_BY_ID = {
  's-marquee': SMarquee, 's-banner': SBanner, 's-embed': SEmbed, 's-grid': SGrid, 's-cta': SCta,
};

// ════════════════════ PORTFOLIO (5) ════════════════════
const PortGrid = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginBottom:4 }}>Selected Work</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3 }}>
      {[IMG.studio, IMG.beach, IMG.art, IMG.city, IMG.mount, IMG.team].map((s,i)=>(
        <div key={i}>
          <img src={s} alt="" style={{ width:'100%', aspectRatio:'1/1.1', objectFit:'cover', borderRadius:2 }}/>
          <div style={{ fontSize:4, color:'#0E0E23', fontWeight:800, marginTop:1 }}>Project {i+1}</div>
        </div>
      ))}
    </div>
  </div>
);
const PortFeature = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', display:'flex' }}>
    <img src={IMG.studio} alt="" style={{ width:'55%', height:'100%', objectFit:'cover' }}/>
    <div style={{ flex:1, padding:12, display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <Chip c="#FCD34D" fg="#0E0E23">FEATURED</Chip>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Featured Project</div>
      <L w="85%" mt={4}/><L w="65%" mt={2}/><L w="75%" mt={2}/>
      <div style={{ background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 8px', borderRadius:3, marginTop:5, alignSelf:'flex-start' }}>VIEW CASE STUDY →</div>
    </div>
  </div>
);
const PortList = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', overflow:'hidden' }}>
    <div style={{ display:'flex', gap:14, fontSize:12, fontWeight:900, color:'#0E0E23', letterSpacing:-0.3 }}>
      <span>NIKE</span><span style={{ opacity:0.3 }}>·</span>
      <span>APPLE</span><span style={{ opacity:0.3 }}>·</span>
      <span>VOGUE</span><span style={{ opacity:0.3 }}>·</span>
      <span>WIRED</span>
    </div>
  </div>
);
const PortQuote = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%', display:'flex', alignItems:'center', gap:8 }}>
    <img src={IMG.studio} alt="" style={{ width:'40%', height:'80%', objectFit:'cover', borderRadius:3 }}/>
    <div style={{ flex:1 }}>
      <div style={{ fontSize:18, color:'#8B5CF6', lineHeight:0.5 }}>“</div>
      <div style={{ fontSize:7, fontFamily:'Georgia, serif', color:'#0E0E23', fontStyle:'italic', lineHeight:1.3, marginTop:2 }}>They transformed our brand.</div>
      <div style={{ fontSize:4, color:'#475569', fontWeight:900, marginTop:3, letterSpacing:0.6, textTransform:'uppercase' }}>— Client Name · CEO</div>
    </div>
  </div>
);
const PortCta = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
    <div>
      <div style={{ fontSize:6, opacity:0.7, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase' }}>Like what you see?</div>
      <div style={{ fontSize:11, fontWeight:900, marginTop:2 }}>See more work</div>
    </div>
    <div style={{ background:'#F97316', color:'#fff', fontSize:6, fontWeight:900, padding:'5px 9px', borderRadius:3 }}>VIEW ALL →</div>
  </div>
);

// ── Iter 189c Phase B · Portfolio — new premium variants (drawn thumbs) ──
const PortCaseStudyHero = () => (
  <div style={{ background:'#FAF6EE', width:'100%', height:'100%', padding:8, display:'grid', gridTemplateColumns:'1fr 1fr', gap:6, alignItems:'center' }}>
    <div>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>CASE STUDY · KINDRED</div>
      <div style={{ fontSize:12, fontWeight:900, color:'#0E0E23', marginTop:3, lineHeight:1.05, fontFamily:'Georgia,serif' }}>How we tripled Kindred&apos;s conversion.</div>
      <div style={{ borderTop:'1px solid rgba(14,14,35,0.15)', borderBottom:'1px solid rgba(14,14,35,0.15)', padding:'4px 0', marginTop:5, display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:3 }}>
        {[
          { l:'CONVERSION',     v:'3×' },
          { l:'REVENUE UPLIFT', v:'$2M' },
          { l:'BUILD TIME',     v:'6 wk' },
        ].map((m, i) => (
          <div key={i}>
            <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23' }}>{m.v}</div>
            <div style={{ fontSize:3, fontWeight:800, letterSpacing:1.2, color:'#0E0E23', opacity:0.6, textTransform:'uppercase' }}>{m.l}</div>
          </div>
        ))}
      </div>
      <div style={{ display:'inline-block', background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:800, padding:'3px 7px', borderRadius:99, marginTop:5 }}>Read →</div>
    </div>
    <div style={{ aspectRatio:'4/5', borderRadius:3, overflow:'hidden' }}>
      <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
    </div>
  </div>
);

const PortClientLogosWall = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:6, display:'flex', flexDirection:'column' }}>
    <div style={{ textAlign:'center', marginBottom:5 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>IN GOOD COMPANY</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Some of the brands we&apos;ve built.</div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gridAutoRows:'1fr', gap:1, background:'rgba(14,14,35,0.15)', flex:1 }}>
      {['Kindred','Meridian','Ossature','Northern','Loam & Ash','Rue Alto','Ferra','Little Lake','Wildwood','Cardigan','Palette','Notes'].map((n, i) => (
        <div key={i} style={{ background:'#fff', display:'flex', alignItems:'center', justifyContent:'center', padding:2 }}>
          <div style={{ fontSize:4.5, fontWeight:900, color:'#0E0E23', opacity:0.6, fontFamily:'Georgia,serif', fontStyle:'italic' }}>{n}</div>
        </div>
      ))}
    </div>
  </div>
);

export const PORTFOLIO_SHAPE_BY_ID = {
  'port-grid': PortGrid, 'port-feature': PortFeature, 'port-list': PortList, 'port-quote': PortQuote, 'port-cta': PortCta,
  // Iter 189c Phase B — new premium Portfolio variants
  'port-case-study-hero':   PortCaseStudyHero,
  'port-client-logos-wall': PortClientLogosWall,
};

// ════════════════════ IMAGES (7) ════════════════════
const ImgGrid3 = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gridAutoRows:'1fr', gap:3 }}>
    {[IMG.studio, IMG.team, IMG.beach, IMG.mount, IMG.city, IMG.art].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:2 }}/>))}
  </div>
);
const ImgLookbook = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', display:'grid', gridTemplateColumns:'1.6fr 1fr', gap:4 }}>
    <img src={IMG.studio} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:2 }}/>
    <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
      <img src={IMG.team} alt="" style={{ width:'100%', flex:1, objectFit:'cover', borderRadius:2 }}/>
      <img src={IMG.art} alt="" style={{ width:'100%', flex:1, objectFit:'cover', borderRadius:2 }}/>
    </div>
  </div>
);
const ImgCarousel = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', overflow:'hidden' }}>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23', marginBottom:3 }}>Featured Work →</div>
    <div style={{ display:'flex', gap:4 }}>
      {[IMG.studio, IMG.team, IMG.beach, IMG.mount, IMG.city].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:46, height:46, objectFit:'cover', borderRadius:2, flexShrink:0 }}/>))}
    </div>
    <div style={{ display:'flex', gap:3, justifyContent:'center', marginTop:5 }}>
      {[1,2,3,4,5].map(i=>(<div key={i} style={{ width:5, height:5, borderRadius:999, background:i===1?'#0E0E23':'#E2E8F0' }}/>))}
    </div>
  </div>
);
const ImgMarquee = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%', overflow:'hidden' }}>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>On the Wall · auto-scroll</div>
    <div style={{ display:'flex', gap:3, marginTop:4 }}>
      {[IMG.studio, IMG.team, IMG.beach, IMG.mount, IMG.city, IMG.art].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:30, height:30, objectFit:'cover', borderRadius:1, flexShrink:0 }}/>))}
    </div>
  </div>
);
const ImgSingleFullbleed = () => (
  <img src={IMG.mount} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
);
const ImgBanner = () => (
  <div style={{ position:'relative', width:'100%', height:'100%' }}>
    <img src={IMG.beach} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:11, fontWeight:900 }}>Caption</div>
  </div>
);
const ImgCircle = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
    <img src={IMG.port3} alt="" style={{ width:60, height:60, borderRadius:999, objectFit:'cover', border:'3px solid #fff', boxShadow:'0 4px 14px rgba(0,0,0,0.1)' }}/>
  </div>
);

// ── Iter 189c Phase B · Gallery — new premium variants (drawn thumbs) ──
const ImgMasonryEditorial = () => {
  const imgs = [
    { src:'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=70', h:60 },
    { src:'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&q=70', h:44 },
    { src:'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&q=70', h:52 },
    { src:'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&q=70', h:36 },
    { src:'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=70', h:64 },
    { src:'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&q=70', h:40 },
  ];
  return (
    <div style={{ background:'#fff', width:'100%', height:'100%', padding:6, display:'flex', flexDirection:'column' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:4 }}>
        <div>
          <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>THE ARCHIVE</div>
          <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', marginTop:1, fontFamily:'Georgia,serif' }}>Selected works.</div>
        </div>
        <div style={{ fontSize:4, opacity:0.6, letterSpacing:1.2, textTransform:'uppercase', fontWeight:800 }}>08 images</div>
      </div>
      <div style={{ columns:3, columnGap:3, flex:1 }}>
        {imgs.map((im, i) => (
          <div key={i} style={{ breakInside:'avoid', marginBottom:3, borderRadius:3, overflow:'hidden', height:im.h }}>
            <img src={im.src} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
          </div>
        ))}
      </div>
    </div>
  );
};

const ImgFullBleedScroll = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:6, display:'flex', flexDirection:'column' }}>
    <div style={{ paddingLeft:2, marginBottom:4 }}>
      <div style={{ fontSize:4, color:'#8B5CF6', fontWeight:900, letterSpacing:1.4, textTransform:'uppercase' }}>IN FRAME</div>
      <div style={{ fontSize:11, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Scroll the story.</div>
    </div>
    <div style={{ display:'flex', gap:3, overflow:'hidden', flex:1 }}>
      {[
        'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=70',
        'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&q=70',
        'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&q=70',
        'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&q=70',
      ].map((src, i) => (
        <div key={i} style={{ minWidth:'55%', aspectRatio:'4/5', borderRadius:3, overflow:'hidden', flexShrink:0 }}>
          <img src={src} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
        </div>
      ))}
    </div>
  </div>
);

export const IMAGES_SHAPE_BY_ID = {
  'img-grid-3': ImgGrid3, 'img-lookbook': ImgLookbook, 'img-carousel': ImgCarousel,
  'img-marquee': ImgMarquee, 'img-single-fullbleed': ImgSingleFullbleed, 'img-banner': ImgBanner, 'img-circle': ImgCircle,
  // Iter 189c Phase B — new premium Gallery variants
  'img-masonry-editorial':  ImgMasonryEditorial,
  'img-full-bleed-scroll':  ImgFullBleedScroll,
};

// ════════════════════ GROUP-EVENTS (5) ════════════════════
const GroupBanner = () => (
  <div style={{ background:'linear-gradient(135deg, #F472B6, #8B5CF6)', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ fontSize:5, opacity:0.85, fontWeight:900, letterSpacing:1, textTransform:'uppercase' }}>Upcoming Event</div>
    <div style={{ fontSize:14, fontWeight:900, marginTop:3 }}>Sat May 25</div>
    <div style={{ fontSize:5, marginTop:3, opacity:0.85 }}>Brooklyn · 7 PM</div>
  </div>
);
const GroupRsvp = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Join us</div>
    <div style={{ fontSize:5, color:'#94A3B8', textAlign:'center', marginTop:1 }}>RSVP for our next gathering</div>
    <div style={{ background:'#fff', padding:5, borderRadius:3, marginTop:5 }}>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2 }}/>
      <div style={{ background:'#F8FAFC', height:7, borderRadius:2, marginTop:3 }}/>
      <div style={{ background:'#10B981', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 0', borderRadius:2, textAlign:'center', marginTop:3 }}>RSVP YES</div>
    </div>
  </div>
);
const GroupSchedule = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Schedule</div>
    {[{t:'10:00',e:'Welcome'},{t:'11:30',e:'Workshop'},{t:'13:00',e:'Lunch'},{t:'15:00',e:'Keynote'}].map((it,i)=>(
      <div key={i} style={{ display:'flex', gap:6, padding:'3px 0', borderBottom:'1px solid #F1F5F9' }}>
        <div style={{ fontSize:6, fontWeight:900, color:'#8B5CF6', minWidth:24 }}>{it.t}</div>
        <div style={{ flex:1, fontSize:6, color:'#0E0E23', fontWeight:700 }}>{it.e}</div>
      </div>
    ))}
  </div>
);
const GroupGallery = () => (
  <div style={{ background:'#fff', padding:6, width:'100%', height:'100%' }}>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23', marginBottom:3 }}>Past events</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:2 }}>
      {[IMG.team, IMG.studio, IMG.art].map((s,i)=>(<img key={i} src={s} alt="" style={{ width:'100%', aspectRatio:'4/3', objectFit:'cover', borderRadius:2 }}/>))}
    </div>
  </div>
);
const GroupTestimonial = TQuotePortrait;

export const GROUP_EVENTS_SHAPE_BY_ID = {
  'group-banner': GroupBanner, 'group-rsvp': GroupRsvp, 'group-schedule': GroupSchedule,
  'group-gallery': GroupGallery, 'group-testimonial': GroupTestimonial,
  // Iter 189c Phase B — new premium Events variants (merged below)
};

// ════════════════════ CONTENT-MEMBERSHIPS (5) ════════════════════
const CmPitch = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center' }}>
    <Chip c="#8B5CF6">Members Only</Chip>
    <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23', marginTop:5 }}>Become a Member</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:2 }}>Unlock exclusive content &amp; community</div>
  </div>
);
const CmTiers = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', textAlign:'center' }}>Plans</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4, marginTop:5 }}>
      {[{n:'Basic',p:'$5'},{n:'Plus',p:'$15',hi:true},{n:'VIP',p:'$45'}].map((t,i)=>(
        <div key={i} style={{ background:t.hi?'#8B5CF6':'#F8FAFC', color:t.hi?'#fff':'#0E0E23', padding:5, borderRadius:3, textAlign:'center' }}>
          <div style={{ fontSize:5, fontWeight:900, letterSpacing:0.6, textTransform:'uppercase', opacity:0.8 }}>{t.n}</div>
          <div style={{ fontSize:10, fontWeight:900, marginTop:2 }}>{t.p}</div>
          <div style={{ fontSize:3, opacity:0.7, marginTop:1 }}>/mo</div>
        </div>
      ))}
    </div>
  </div>
);
const CmContentFeed = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>Latest Posts</div>
    {[{i:IMG.studio,t:'Article 1'},{i:IMG.team,t:'Article 2'},{i:IMG.art,t:'Article 3'}].map((it,k)=>(
      <div key={k} style={{ display:'flex', gap:5, padding:'3px 0', borderBottom:'1px solid #F1F5F9' }}>
        <img src={it.i} alt="" style={{ width:18, height:18, borderRadius:2, objectFit:'cover' }}/>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:5, fontWeight:800, color:'#0E0E23' }}>{it.t}</div>
          <L w="80%" mt={1}/>
        </div>
      </div>
    ))}
  </div>
);
const CmQuote = TQuotePortrait;
const CmCta = () => (
  <div style={{ background:'linear-gradient(135deg, #8B5CF6, #6366F1)', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
    <div style={{ fontSize:11, fontWeight:900 }}>Join today</div>
    <div style={{ background:'#fff', color:'#8B5CF6', fontSize:6, fontWeight:900, padding:'5px 8px', borderRadius:3 }}>BECOME MEMBER →</div>
  </div>
);

export const MEMBERSHIPS_SHAPE_BY_ID = {
  'cm-pitch': CmPitch, 'cm-tiers': CmTiers, 'cm-content-feed': CmContentFeed,
  'cm-quote': CmQuote, 'cm-cta': CmCta,
};

// ════════════════════ SCHEDULING (5) ════════════════════
const SchedBook = CalMonth;
const SchedServices = () => (
  <div style={{ background:'#fff', padding:8, width:'100%', height:'100%' }}>
    <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>Pick a Service</div>
    {[{n:'Brand Consult',p:'$120',d:'45 min'},{n:'Design Review',p:'$200',d:'60 min'},{n:'Full Audit',p:'$500',d:'2 hours'}].map((it,i)=>(
      <div key={i} style={{ display:'flex', alignItems:'center', gap:5, padding:'4px 0', borderBottom:'1px solid #F1F5F9' }}>
        <div style={{ width:18, height:18, borderRadius:999, background:'#F1F5F9', display:'flex', alignItems:'center', justifyContent:'center', fontSize:7 }}>⏱</div>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:6, fontWeight:900, color:'#0E0E23' }}>{it.n}</div>
          <div style={{ fontSize:4, color:'#94A3B8' }}>{it.d}</div>
        </div>
        <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23' }}>{it.p}</div>
      </div>
    ))}
  </div>
);
const SchedHours = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
    <div style={{ textAlign:'center' }}>
      <Chip c="#10B981">● OPEN</Chip>
      <div style={{ fontSize:11, fontWeight:900, marginTop:5 }}>Mon–Fri · 9–5</div>
    </div>
  </div>
);
const SchedForm = FQuote;
const SchedFaq = FaqAccordion;

export const SCHEDULING_SHAPE_BY_ID = {
  'sched-book': SchedBook, 'sched-services': SchedServices, 'sched-hours': SchedHours,
  'sched-form': SchedForm, 'sched-faq': SchedFaq,
};


// ════════════════════ TEAM (6) — Iter 189c Phase B ════════════════════
// Unsplash portrait stock for the team miniatures.
const P = {
  a: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=70',
  b: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=70',
  c: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=70',
  d: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=200&q=70',
  e: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=70',
  f: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&q=70',
  g: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=200&q=70',
  h: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=70',
};

const TeamDefaultGrid = () => (
  <div style={{ background: '#fff', padding: 10, width: '100%', height: '100%' }}>
    <div style={{ fontSize: 5, letterSpacing: 1.2, color: '#8B5CF6', fontWeight: 900, textAlign: 'center' }}>THE CREW</div>
    <div style={{ fontSize: 8, fontWeight: 900, color: '#0E0E23', textAlign: 'center', marginTop: 1 }}>Meet the team</div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 4, marginTop: 6 }}>
      {[P.a, P.b, P.c, P.d].map((s, i) => (
        <div key={i} style={{ textAlign: 'center' }}>
          <img src={s} alt="" style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', borderRadius: 3 }} />
          <div style={{ fontSize: 5, fontWeight: 900, color: '#0E0E23', marginTop: 2 }}>Team</div>
          <div style={{ fontSize: 4, color: '#94A3B8' }}>Role</div>
        </div>
      ))}
    </div>
  </div>
);

const TeamPalmLeaf = () => (
  <div style={{ position: 'relative', width: '100%', height: '100%', background: 'linear-gradient(135deg,#065F46,#0F766E)', padding: 10 }}>
    <div style={{ position: 'absolute', inset: 6, background: '#fff', borderRadius: 5, padding: 8 }}>
      <div style={{ fontSize: 7, fontWeight: 900, color: '#0E0E23', textAlign: 'center' }}>Our Crew</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, marginTop: 6 }}>
        {[P.a, P.b, P.c].map((s, i) => (
          <div key={i} style={{ textAlign: 'center' }}>
            <img src={s} alt="" style={{ width: 20, height: 20, borderRadius: 999, objectFit: 'cover', margin: '0 auto' }} />
            <div style={{ fontSize: 5, fontWeight: 900, color: '#0E0E23', marginTop: 2 }}>Name</div>
            <div style={{ fontSize: 4, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: 0.5 }}>Role</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const TeamSquareCards = () => (
  <div style={{ background: '#FAF6EE', padding: 8, width: '100%', height: '100%' }}>
    <div style={{ fontSize: 7, fontWeight: 900, color: '#0E0E23', textAlign: 'center' }}>Better crew for your startup</div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3, marginTop: 5 }}>
      {[P.a, P.b, P.c, P.d, P.e, P.f, P.g, P.h].map((s, i) => (
        <div key={i}>
          <img src={s} alt="" style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover' }} />
          <div style={{ fontSize: 4, fontWeight: 900, color: '#0E0E23', marginTop: 1 }}>Name</div>
        </div>
      ))}
    </div>
  </div>
);

const TeamVioletBg = () => (
  <div style={{ background: '#3B1F8B', padding: 10, width: '100%', height: '100%', color: '#fff' }}>
    <div style={{ fontSize: 7, fontWeight: 900, textAlign: 'center' }}>Startup Crew</div>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 4, marginTop: 8 }}>
      {[P.a, P.b, P.c, P.d, P.e].map((s, i) => (
        <div key={i} style={{ textAlign: 'center' }}>
          <img src={s} alt="" style={{ width: 16, height: 16, borderRadius: 999, objectFit: 'cover', margin: '0 auto' }} />
          <div style={{ fontSize: 4, fontWeight: 900, marginTop: 2 }}>Name</div>
          <div style={{ fontSize: 3, opacity: 0.7, textTransform: 'uppercase' }}>Role</div>
        </div>
      ))}
    </div>
  </div>
);

const TeamOrgChartTree = () => (
  <div style={{ background: '#FAF6EE', padding: 10, width: '100%', height: '100%' }}>
    <div style={{ fontSize: 4, letterSpacing: 1.2, color: '#8B5CF6', fontWeight: 900, textAlign: 'center' }}>LEADERSHIP</div>
    <div style={{ fontSize: 7, fontWeight: 900, color: '#0E0E23', textAlign: 'center', marginTop: 1 }}>Steering the ship</div>
    {/* Leader */}
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 5 }}>
      <img src={P.f} alt="" style={{ width: 22, height: 22, borderRadius: 999, objectFit: 'cover', boxShadow: '0 0 0 2px #8B5CF6' }} />
      <div style={{ fontSize: 5, fontWeight: 900, color: '#0E0E23', marginTop: 2 }}>Founder</div>
      <div style={{ width: 1, height: 8, background: '#0E0E2333', marginTop: 3 }} />
      <div style={{ width: '85%', height: 1, background: '#0E0E2333' }} />
    </div>
    {/* Reports */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3, marginTop: 0 }}>
      {[P.a, P.b, P.c, P.d].map((s, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ width: 1, height: 5, background: '#0E0E2333' }} />
          <img src={s} alt="" style={{ width: 14, height: 14, borderRadius: 999, objectFit: 'cover', marginTop: 1 }} />
          <div style={{ fontSize: 3.5, fontWeight: 900, color: '#0E0E23', marginTop: 1 }}>Lead</div>
        </div>
      ))}
    </div>
  </div>
);

const TeamFounderSpotlight = () => (
  <div style={{ background: '#FAF6EE', padding: 8, width: '100%', height: '100%', display: 'flex', gap: 8 }}>
    <div style={{ width: '38%' }}>
      <img src={P.f} alt="" style={{ width: '100%', aspectRatio: '4/5', objectFit: 'cover', borderRadius: 3 }} />
      <div style={{ fontSize: 5, fontWeight: 900, color: '#0E0E23', marginTop: 2 }}>Amelia</div>
      <div style={{ fontSize: 3.5, color: '#94A3B8' }}>Founder</div>
    </div>
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ fontSize: 3.5, color: '#8B5CF6', fontWeight: 900, letterSpacing: 1 }}>FOUNDER SPOTLIGHT</div>
      <div style={{ fontSize: 8, fontWeight: 900, color: '#0E0E23', marginTop: 2, lineHeight: 1.15 }}>Quiet obsession.</div>
      <div style={{ fontSize: 4, fontStyle: 'italic', color: '#0E0E23', marginTop: 3, borderLeft: '1px solid #8B5CF6', paddingLeft: 3, lineHeight: 1.35 }}>&ldquo;We build what we wish existed.&rdquo;</div>
      <div style={{ marginTop: 5, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {[P.a, P.b, P.c].map((s, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 3, borderTop: '1px solid #0E0E2315', paddingTop: 2 }}>
            <img src={s} alt="" style={{ width: 8, height: 8, borderRadius: 999, objectFit: 'cover' }} />
            <div style={{ fontSize: 3.5, fontWeight: 900, color: '#0E0E23' }}>Teammate</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const TEAM_SHAPE_BY_ID = {
  'team-default-grid':      TeamDefaultGrid,
  'team-palm-leaf-bg':      TeamPalmLeaf,
  'team-square-cards':      TeamSquareCards,
  'team-violet-bg':         TeamVioletBg,
  'team-org-chart-tree':    TeamOrgChartTree,
  'team-founder-spotlight': TeamFounderSpotlight,
};

// ════════════════════ CTA (8) — Iter 189c Phase B ════════════════════
const CtaDefaultDark = () => (
  <div style={{ background:'#0E0E23', width:'100%', height:'100%', padding:16, textAlign:'center', color:'#fff', display:'flex', flexDirection:'column', justifyContent:'center' }}>
    <div style={{ fontSize:10, fontWeight:900, lineHeight:1.15 }}>Ready to build something remarkable?</div>
    <div style={{ fontSize:5, opacity:0.7, marginTop:3 }}>Book a call and we&rsquo;ll map out the first ninety days.</div>
    <div style={{ marginTop:8, display:'flex', gap:5, justifyContent:'center' }}>
      <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 8px', borderRadius:999 }}>BOOK A CALL</div>
      <div style={{ border:'1px solid #fff', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 8px', borderRadius:999 }}>CASE STUDIES</div>
    </div>
  </div>
);
const CtaImageHero = () => (
  <div style={{ position:'relative', width:'100%', height:'100%', overflow:'hidden' }}>
    <img src="https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=800&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.55)' }} />
    <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', color:'#fff', padding:10 }}>
      <div style={{ fontSize:10, fontWeight:900, lineHeight:1.15 }}>Bring your project to life.</div>
      <div style={{ fontSize:5, opacity:0.85, marginTop:3 }}>Studio partners for founders.</div>
      <div style={{ marginTop:7, background:'#fff', color:'#0E0E23', fontSize:5, fontWeight:900, padding:'4px 10px' }}>START A PROJECT</div>
    </div>
  </div>
);
const CtaPillBar = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center' }}>
    <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23' }}>Get 15% off your first order</div>
    <div style={{ fontSize:5, color:'#94A3B8', marginTop:2 }}>Sign up to our newsletter</div>
    <div style={{ marginTop:6, display:'flex', gap:0, background:'#fff', borderRadius:999, padding:2, border:'1px solid #0E0E2315' }}>
      <div style={{ padding:'3px 10px', fontSize:5, color:'#94A3B8' }}>Email address</div>
      <div style={{ padding:'3px 10px', fontSize:5, fontWeight:900, color:'#fff', background:'#8B5CF6', borderRadius:999 }}>SUBSCRIBE</div>
    </div>
  </div>
);
const CtaMountainOverlay = () => (
  <div style={{ position:'relative', width:'100%', height:'100%', overflow:'hidden' }}>
    <img src={IMG.mount} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
    <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.65) 100%)' }} />
    <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:10, color:'#fff' }}>
      <div style={{ fontSize:10, fontWeight:900, lineHeight:1.1 }}>Reach new heights.</div>
      <div style={{ fontSize:4.5, opacity:0.85, marginTop:2 }}>Zero platform fees.</div>
      <div style={{ marginTop:5, display:'flex', gap:4 }}>
        <div style={{ background:'#8B5CF6', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 8px', borderRadius:999 }}>START FREE</div>
        <div style={{ border:'1px solid #fff', color:'#fff', fontSize:5, fontWeight:900, padding:'3px 8px', borderRadius:999 }}>WATCH DEMO</div>
      </div>
    </div>
  </div>
);
const CtaSlimPromoBar = () => (
  <div style={{ background:'#0E0E23', color:'#fff', padding:'14px 16px', width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
    <div>
      <div style={{ fontSize:4, fontWeight:900, letterSpacing:1, color:'#F97316' }}>LIMITED TIME</div>
      <div style={{ fontSize:8, fontWeight:900, marginTop:2 }}>Spring sale &mdash; 30% off</div>
    </div>
    <div style={{ background:'#F97316', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 8px', borderRadius:4 }}>SHOP &rarr;</div>
  </div>
);
const CtaAppStoreBadges = () => (
  <div style={{ background:'#3B1F8B', color:'#fff', padding:14, width:'100%', height:'100%', display:'flex', gap:8, alignItems:'center' }}>
    <div style={{ flex:1 }}>
      <div style={{ fontSize:9, fontWeight:900, lineHeight:1.15 }}>Take it on the go.</div>
      <div style={{ fontSize:5, opacity:0.85, marginTop:3 }}>Download the app.</div>
      <div style={{ marginTop:6, display:'flex', gap:3 }}>
        <div style={{ background:'#000', border:'1px solid #333', color:'#fff', fontSize:4, fontWeight:900, padding:'3px 6px', borderRadius:3 }}>App Store</div>
        <div style={{ background:'#000', border:'1px solid #333', color:'#fff', fontSize:4, fontWeight:900, padding:'3px 6px', borderRadius:3 }}>Google Play</div>
      </div>
    </div>
    <div style={{ width:40, height:70, background:'#000', borderRadius:5, border:'1px solid #6366F1' }} />
  </div>
);
const CtaVideoModal = () => (
  <div style={{ position:'relative', width:'100%', height:'100%', overflow:'hidden' }}>
    <img src={IMG.studio} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.45)' }} />
    <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', color:'#fff', padding:10 }}>
      <div style={{ width:24, height:24, borderRadius:999, background:'rgba(255,255,255,0.95)', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:5, boxShadow:'0 3px 8px rgba(0,0,0,0.3)' }}>
        <div style={{ width:0, height:0, borderLeft:'7px solid #0E0E23', borderTop:'5px solid transparent', borderBottom:'5px solid transparent', marginLeft:2 }} />
      </div>
      <div style={{ fontSize:9, fontWeight:900 }}>See it in motion</div>
      <div style={{ fontSize:4.5, opacity:0.85, marginTop:2 }}>90-second product tour</div>
    </div>
  </div>
);
const CtaWhiteBordered = () => (
  <div style={{ background:'#FAF6EE', padding:14, width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
    <div style={{ background:'#fff', border:'2px solid #0E0E23', borderRadius:8, padding:14, textAlign:'center', width:'85%' }}>
      <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23' }}>Talk to our team</div>
      <div style={{ fontSize:4.5, color:'#94A3B8', marginTop:2 }}>Reply within one business day.</div>
      <div style={{ marginTop:5, background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:900, padding:'4px 10px', display:'inline-block' }}>CONTACT SALES</div>
    </div>
  </div>
);

export const CTA_SHAPE_BY_ID = {
  'cta-default-dark':         CtaDefaultDark,
  'cta-image-hero':           CtaImageHero,
  'cta-pill-bar':             CtaPillBar,
  'cta-mountain-overlay':     CtaMountainOverlay,
  'cta-slim-promo-bar':       CtaSlimPromoBar,
  'cta-app-store-badges':     CtaAppStoreBadges,
  'cta-video-modal':          CtaVideoModal,
  'cta-white-bordered-card':  CtaWhiteBordered,
};

// ════════════════════ EVENTS (3) — Iter 189c Phase B ════════════════════
const EventsGrid3Up = () => (
  <div style={{ background:'#fff', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:4, letterSpacing:1.2, color:'#8B5CF6', fontWeight:900, textAlign:'center' }}>UPCOMING</div>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center', marginTop:1 }}>Events this season</div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4, marginTop:6 }}>
      {[IMG.city, IMG.studio, IMG.art].map((s,i)=>(
        <div key={i} style={{ border:'1px solid #0E0E2315', borderRadius:3, overflow:'hidden' }}>
          <img src={s} alt="" style={{ width:'100%', aspectRatio:'4/3', objectFit:'cover' }} />
          <div style={{ padding:3 }}>
            <div style={{ fontSize:3.5, fontWeight:900, color:'#8B5CF6', letterSpacing:0.8 }}>{['MAR 12','APR 04','MAY 22'][i]}</div>
            <div style={{ fontSize:5, fontWeight:900, color:'#0E0E23', marginTop:1 }}>{['Founders','Workshop','Meetup'][i]}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
const EventsAgendaList = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:4, letterSpacing:1.2, color:'#8B5CF6', fontWeight:900, textAlign:'center' }}>AGENDA</div>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', textAlign:'center', marginTop:1 }}>What&rsquo;s on the schedule</div>
    <div style={{ marginTop:5, display:'flex', flexDirection:'column', gap:3 }}>
      {['09:00','10:00','11:30','13:00'].map((t,i)=>(
        <div key={i} style={{ display:'flex', alignItems:'center', gap:5, borderTop:'1px solid #0E0E2315', paddingTop:3 }}>
          <div style={{ background:'#8B5CF6', color:'#fff', fontSize:4.5, fontWeight:900, padding:'2px 5px', borderRadius:2, minWidth:26, textAlign:'center' }}>{t}</div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:5, fontWeight:900, color:'#0E0E23' }}>{['Registration','Opening Keynote','Panel &middot; Trust','Lunch'][i]}</div>
            <div style={{ fontSize:3.5, color:'#94A3B8', textTransform:'uppercase', letterSpacing:0.5 }}>Room A</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
const EventsFeaturedHero = () => (
  <div style={{ background:'#FAF6EE', padding:10, width:'100%', height:'100%' }}>
    <div style={{ fontSize:4, letterSpacing:1.2, color:'#8B5CF6', fontWeight:900 }}>UPCOMING</div>
    <div style={{ fontSize:8, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Worth blocking your calendar</div>
    <div style={{ marginTop:5, display:'grid', gridTemplateColumns:'2fr 1fr', gap:4 }}>
      <div style={{ position:'relative', borderRadius:3, overflow:'hidden', minHeight:80 }}>
        <img src={IMG.city} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.85))' }} />
        <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', justifyContent:'flex-end', padding:5, color:'#fff' }}>
          <div style={{ fontSize:3.5, fontWeight:900, color:'#F0ABFC' }}>JUN 07</div>
          <div style={{ fontSize:7, fontWeight:900 }}>Founders Summit</div>
        </div>
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
        {[IMG.studio, IMG.art, IMG.beach].map((s,i)=>(
          <div key={i} style={{ position:'relative', borderRadius:2, overflow:'hidden', height:24 }}>
            <img src={s} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', padding:3, color:'#fff', fontSize:4, fontWeight:900 }}>Event {i+2}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const EVENTS_SHAPE_BY_ID = {
  'events-grid-3up':      EventsGrid3Up,
  'events-agenda-list':   EventsAgendaList,
  'events-featured-hero': EventsFeaturedHero,
};

